import { Apollo, QueryRef } from 'apollo-angular';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { SessionVariables, screenIdsForTelemetry, ErrorCodes } from '../../constants';
import { DynamicComponentCreateService } from '../../gcs.business.services/dynamic-component-create.service';
import { GcsGraphQlSessionIdServiceSecure } from './gcs.graph-ql.session-id.service.secure';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { GcsGraphQlsetbBfoLogsServiceSecure } from './gcs.graph-ql.gcs-set-bfoLogs.service.secure';
@Injectable({
  providedIn: 'root'
})

export class GcsGraphQlSubmitCaseServiceSecure {


  constructor(
    private apollo: Apollo,
    private service: DynamicComponentCreateService,
    private gcsGraphQlSessionIdServiceSecure: GcsGraphQlSessionIdServiceSecure,
    private httpClient: HttpClient,
    private gcsGraphQlsetbBfoLogsServiceSecure: GcsGraphQlsetbBfoLogsServiceSecure) { }

  public genSubmitCase(valueObject: any): void {
    debugger
    this.service.WritelogToCloudWatch(valueObject)
    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm));
    const createCaseGenForm = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseGenForm));
    const loggedIDetails = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const getAllContacts = JSON.parse(sessionStorage.getItem(SessionVariables.getContacts));
    const loggedData: any = loggedIDetails.data;
    const loggedUserInfo = loggedData.getLoggedInUserInfo;
    let contactDetails: any;
    let isContactFind = false;
    for (const item of getAllContacts) {
      const name = `${item.firstName} ${item.lastName}`;
      const itemCFID = parseInt(item.customerContactNumber, 10);
      if (name === createCaseFirstFormData.contact) {
        contactDetails = item;
        isContactFind = true;
        break;
      }
    }
    if (!contactDetails) {
      for (const item of getAllContacts) {
        const itemCFID = parseInt(item.customerContactNumber, 10);
        if (loggedUserInfo.CFIDList && loggedUserInfo.CFIDList.includes(itemCFID)) {
          contactDetails = item;
          isContactFind = true;
          break;
        }
      }
    }
    if (!isContactFind) {
      const loggedName = `${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`;
      if (createCaseFirstFormData.contact === loggedName) {
        const loggedObject = {
          phone: loggedUserInfo.workPhone,
          email: loggedUserInfo.email,
          customerContactNumber: loggedUserInfo.CFID
        };
        contactDetails = loggedObject;
      }
    }

    const siteGuid = createCaseFirstFormData.site ? `"{${createCaseFirstFormData.site}}"` : null;

    let brandProductCode: any;
    for (const item of JSON.parse(sessionStorage.getItem(SessionVariables.getProduct))) {
      if (item.prodTypeCode === createCaseGenForm.product) {
        brandProductCode = item.brandProductCode;
      }
    }

    const firstName = loggedUserInfo.firstName || '';
    const middleName = loggedUserInfo.middleName || '';
    const lastName = loggedUserInfo.lastName || '';
    const submitterPhone = loggedUserInfo.workPhone || '';
    const phone = contactDetails.phone || '';
    const submitterUserName = `${firstName} ${middleName} ${lastName}`;
    const selectedCompany = sessionStorage.getItem(SessionVariables.selectedCompany);
    const selectedPriority = sessionStorage.getItem(SessionVariables.selectedPriority);
    const selectedSite = sessionStorage.getItem(SessionVariables.selectedSite);

    // need to strip the single quotes out of the company name, or the send email function could fail
    let checkCompany:any = selectedCompany;
    checkCompany = checkCompany.replaceAll('\'', "''");
    
    
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    let emailDescription: string;
    let emailConfiguration: string;
    let emailsiteSelected = (selectedSite === null || selectedSite === '' || selectedSite === undefined) ? '-' : selectedSite;
    let emailgenCustRef = (createCaseFirstFormData.customerref === null || createCaseFirstFormData.customerref === '' || createCaseFirstFormData.customerref === undefined) ? '-' : createCaseFirstFormData.customerref;

    if (createCaseGenForm && createCaseGenForm.description) {
      let checkDesc = createCaseGenForm.description;
       checkDesc = checkDesc.replaceAll('\'', "''");
       checkDesc = checkDesc.replaceAll('\"', "''");

      createCaseGenForm.description = checkDesc.trim();
      emailDescription = createCaseGenForm.description.replaceAll('\n', '<br/>');
    }
    else if (createCaseGenForm.description === null || createCaseGenForm.description === '' || createCaseGenForm.description === undefined) {
      emailDescription = '-';
    }


    if (createCaseGenForm && createCaseGenForm.configuration && createCaseGenForm.configuration !== '') {
      let checkConfig = createCaseGenForm.configuration;
       checkConfig = checkConfig.replaceAll('\'', "''");
       checkConfig = checkConfig.replaceAll('\"', "''");
       createCaseGenForm.configuration = `""${checkConfig.trim()}""`;
      emailConfiguration = checkConfig.replaceAll('\n', '<br/>');
    }
    else if (createCaseGenForm.configuration === null || createCaseGenForm.configuration === '' || createCaseGenForm.configuration === undefined) {
      emailConfiguration = '-';
    }

    if (valueObject && valueObject.reproducible) {
      let checkReprod = valueObject.reproducible;
      checkReprod = checkReprod.replaceAll('\'', "''");
      valueObject.reproducible = checkReprod.trim();
    }
    let emailDateOccured: any;
    if (createCaseFirstFormData && createCaseFirstFormData.dateoccurred) {
      let splitDate: any;
      if (createCaseFirstFormData.dateoccurred.includes('T')) {
        splitDate = createCaseFirstFormData.dateoccurred.split('T');
      }
      emailDateOccured = splitDate && splitDate[0];
    }
    createCaseFirstFormData.customerref =createCaseFirstFormData.customerref.replaceAll('\'', "''").replaceAll('\"', "''")
    createCaseFirstFormData.customerref =this.service.escape(createCaseFirstFormData.customerref)
     createCaseGenForm.configuration =this.service.escape(createCaseGenForm.configuration)
     createCaseGenForm.description =this.service.escape(createCaseGenForm.description)
    debugger;
    this.apollo.mutate({
      mutation: gql`
        mutation{
          createCaseWithNotification(input:{
            caseTypeCode:"${createCaseFirstFormData.caseType}",
            carNumber:null,
            localCompanyCode:${createCaseFirstFormData.company},
            siteGuid:${siteGuid},
            contactFullName:"${createCaseFirstFormData.contact}",
            contactId:"${contactDetails.customerContactNumber}",
            phone:"${phone}",
            email:"${contactDetails.email}",
            SEContactName:"",
            SEConactPhone:"",
            SEContactEmail:"",
            submitterFullName:"${submitterUserName}",
            submitterPhone:"${submitterPhone}",
            submitterEmail:"${loggedUserInfo.email}",
            dateOccured:"${createCaseFirstFormData.dateoccurred}",
            locationCode:"${createCaseGenForm.area}",
            reproducibleCode:"${createCaseGenForm.reproducible}",
            impactCode:"${createCaseFirstFormData.priority}",
            issueType:"",
            brandProductCode:${brandProductCode},
            hardwareCode:"9",
            versionCode:"${createCaseGenForm.productversion}",
            customerRefField:"${createCaseFirstFormData.customerref}",
            configurationInput:"${createCaseGenForm.configuration}",
            descriptionInput:"""${createCaseGenForm.description}""",
            suggestedSolution:"",
            benefitText:"",
            CRUserId:"",
            RMACode:"",
            carTypeCode:1,
            caseType:"${createCaseFirstFormData.caseType}",
            salesOrderNumber:"",
            serviceOrderNumber:"",
            SAFEffect:"I",
            PONumber:"",
            POEndDate:"",
            webCode:null,
            newCaseGUID:null,
            qualCode:"",
            goldenID:"" ,
            company:"${valueObject.company}",
            site:"${valueObject.site}",
            productFamily:"${valueObject.productFamily}",
            productGroup:"${valueObject.productGroup}",
            product:"${valueObject.product}",
            productVersion:"${valueObject.productVersion}",
            priority:"${valueObject.priority}",
            area:"${valueObject.area}",
            reproducible:"${valueObject.reproducible}",
            JWT: "${sessionToken}",
            screenId: "${screenId}",
            ipAddress: "${ip}"
          }){
            caseNumber
            message
            notificationId
          }
        }
   `,
    })
      .subscribe(data => {

        this.service.WritelogToCloudWatch("case submitted successfully",data)
        debugger;
        const getData: any = (data && data.data) || {};

        sessionStorage.setItem(SessionVariables.genSubmitCaseData, JSON.stringify(getData && getData.createCaseWithNotification));
        this.service.genCaseTypeSubmitCase.next(true);
        const emailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div>Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.createCaseWithNotification.caseNumber}.</b><br/> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${checkCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${selectedPriority}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailsiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailgenCustRef}</span></div><div> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${valueObject.productFamily}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${valueObject.productGroup}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${valueObject.product}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${valueObject.productVersion}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${valueObject.area}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${valueObject.reproducible}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfiguration}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${emailDescription}</span></div></div></div></div></body></html>`;

        const ccEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${checkCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${selectedPriority}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailsiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailgenCustRef}</span></div><div> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${valueObject.productFamily}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${valueObject.productGroup}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${valueObject.product}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${valueObject.productVersion}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${valueObject.area}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${valueObject.reproducible}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfiguration}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${emailDescription}</span></div></div></div></div></body></html>`;
        const genSubmitData = JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData)) || null;
        if (genSubmitData && genSubmitData !== undefined && genSubmitData !== null) {
          this.emailNotification(emailTemp, contactDetails.email, createCaseFirstFormData.company,
            genSubmitData.caseNumber, ccEmailTemp, emailDescription, 'GEN');
        }
      },
        (err) => {
          this.service.WritelogToCloudWatch(err)
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.genSubmitCase(valueObject);
                }
              })
          }
          else {
            const userCode = this.service.getIds();

            this.service.errorLogHandling.next({
              userCode: userCode.user_code,
              LogText: "genSubmitCase",
              SourceApp: "GCSWeb2020",
              API_HTTP_Code: "5000",
              API_Error_Code: "5000",
              API_URL: "",
              API_Error_Type: err.name,
              API_UserMessage: "Unable to Submit Form: Please contact local support for assistance.",
              API_DevMessage: err.stack,
              API_Data: ''
            });


          }
        });
  }

  // GEN-summary //

  public getGenSummary(userCode: number, caseNumber: any, caseType: any): void {
    let userGenQuery: QueryRef<any>;
    const getuserCode = userCode || sessionStorage.getItem(SessionVariables.homeUseCode);
    if (!caseNumber && !caseType) {
      const homeCaseNumber = sessionStorage.getItem(SessionVariables.homeCaseNumber) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData)).caseNumber;
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    userGenQuery = this.apollo.watchQuery({
      query: gql`query{
        GENViewCaseSummarySecure(input:{
          caseTypeCode:"${caseType}",
          caseNumber:${caseNumber},
          JWT: "${sessionToken}",
          screenId: "${screenId}",
          ipAddress: "${ip}"
        }){
          GENViewCaseSummary{
            caseNumber
            status
            caseType
            priority
            company
            site
            contact
            customerRef
            submittedBy
            dateOccurred
            submittedDate
            nextUpdate
            caseOwner
            family
            group
            productInfo
            version
            area
            repro
            configuration
            description
            answerToCust
            comments
          }
        }
      }
       `,
    });

    userGenQuery.valueChanges.subscribe((result) => {

      const resultData = result && result.data;
      const summaryData = resultData && resultData.GENViewCaseSummarySecure && resultData.GENViewCaseSummarySecure.GENViewCaseSummary;
      sessionStorage.setItem(SessionVariables.genSummaryCaseData, JSON.stringify(summaryData));
      this.service.genCaseTypeSummaryCase.next(true);
    },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.getGenSummary(userCode, caseNumber, caseType);
              }
            })
        }
      });
  }
  // GEN-summary //

  // TEC & PER-summary //
  public getTECPERSummary(accessToken: number, caseId: any, caseType: any): void {
    let tecSummaryQuery: QueryRef<any>;
    if (!caseId && !caseType) {
      const homeCaseId = sessionStorage.getItem(SessionVariables.homeCaseId) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      caseId = parseInt(homeCaseId) || JSON.parse(sessionStorage.getItem(SessionVariables.TecOrPerSubmitCaseData)).caseId;
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = screenIdsForTelemetry['case-summary'].screenId;
    tecSummaryQuery = this.apollo.watchQuery({
      query: gql`query MyQuery {
        bfoGetCaseDetails(input:{
          caseId: "${caseId}",
          screenId: "${screenId}",
          JWT: "${sessionToken}",
          ipAddress: "${ip}"
        }) {
          accountId
          paAccountName
          accountName
          accountSEAccountId
          alarmDateAndTime
          caseId
          caseNumber
          caseResolvingAgentId
          caseResolvingAgentName
          commercialReference
          communitySource
          contactId
          contactName
          contractId
          contractNumberName
          createdDate
          customerRequest
          customerStatus
          lastModifiedDate
          origin
          paCaseType
          paContactCfid
          paCustomerInternalCaseNumber
          paHotCase
          paTargetDate
          priority
          productFamily
          productRange
          siteGuid
          siteName
          subject
          warrantyEndDate
          brandName
          brandProductName
          brandGroupName
          versionName
          answerProvidedToCustomer
          bfoApiUrl
          bfoApiPayload
          bfoErrorMsg
          bfoStatusCode
        }
      }
       `,
    });

    tecSummaryQuery.valueChanges.subscribe(
      (result) => {

        const resultData = result && result.data;
        const summaryData = resultData && resultData.bfoGetCaseDetails;
        let bfoCaseType = summaryData.paCaseType.charAt(0);
        if (summaryData.bfoStatusCode && summaryData.bfoStatusCode == 200) {
          if (caseType === 'TEC' || bfoCaseType === 'T' || caseType === 'RWS') {
            sessionStorage.setItem(SessionVariables.tecSummaryCaseData, JSON.stringify(summaryData));
            this.service.tecCaseTypeSummaryCase.next(true);
          }
          if (caseType === 'PER' || bfoCaseType === 'P') {
            sessionStorage.setItem(SessionVariables.perSummaryCaseData, JSON.stringify(summaryData));
            this.service.perCaseTypeSummaryCase.next(true);
          }
        } else {
          this.httpClient.get(environment.errorBfoJson).subscribe((data: Array<any>) => {

            let userMsg = JSON.parse(summaryData.bfoErrorMsg) || {};
            const userCode = this.service.getIds();

            let errorDataList = data.filter((errorItem) => {
              if (errorItem.API_URL === summaryData.bfoApiUrl
                && errorItem.API_Error_Code === userMsg.code
                && errorItem.HTTP_Code === summaryData.bfoStatusCode) {
                return errorItem;
              }
            });
            if (errorDataList.length !== 0) {
              let errdetails = errorDataList[0];
              this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", errdetails.HTTP_Code, errdetails.API_Error_Code,
                errdetails.API_URL, errdetails.API_Error_Type, errdetails.API_UserMessage, userMsg.developerMessage, (summaryData.bfoApiPayload &&
                  summaryData.bfoApiPayload.replace(/['"]+/g, '')));
            }
            else {
              this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", summaryData.bfoStatusCode, userMsg.code,
                summaryData.bfoApiUrl, "", userMsg.userMessage, userMsg.developerMessage,
                (summaryData.bfoApiPayload && summaryData.bfoApiPayload.replace(/['"]+/g, '')));
            }

          })
        }
      },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.getTECPERSummary(accessToken, caseId, caseType);
              }
            })
        }
      }
    );
  }
  // TEC & PER-summary //

  // MEP-Summary //

  public getMEPSummary(userCode: number, caseNumber: any, caseType: any): void {
    let getMEPSummaryQuery: QueryRef<any>;
    const getuserCode = userCode || sessionStorage.getItem(SessionVariables.homeUseCode);
    if (!caseNumber && !caseType) {
      const homeCaseNumber = sessionStorage.getItem(SessionVariables.homeCaseNumber) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.mepSubmitCaseData)).caseNumber;
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    getMEPSummaryQuery = this.apollo.watchQuery({
      query: gql`query MyQuery {
        gcsViewCaseSummaryDetailsSecure(input:
          {
            caseNumber: "${caseNumber}",
             caseTypeCode: "${caseType}",
             JWT: "${sessionToken}",
             screenId: "${screenId}",
             ipAddress: "${ip}"
          }) {
          RequestType
          answerToCust
          area
          billToInfo
          caseNumber
          caseOwner
          caseType
          comments
          company
          configuration
          contact
          contamination
          contract
          customerRef
          dateOccurred
          decontaminateSteps
          description
          exposedTo
          family
          group
          mepCreateDate
          mepModifyDate
          nextUpdate
          priority
          processDown
          processType
          processWetted
          productInfo
          repro
          reqDelivDate
          shipToDesc
          shipToInfo
          site
          softwareVersion
          specialInstructions
          status
          submittedBy
          submittedDate
          version
          warranty
          warrantyExpires
          billToDesc
          PONumber
          POEndDate
          parts {
            description
            failureType
            failureTypeDesc
            partCreateDate
            partModifyDate
            partNumber
            quantity
            rev
            serialNumber
            serviceTime
          }
        }
      }
       `,
    });

    getMEPSummaryQuery.valueChanges.subscribe(
      (result) => {

        const resultData = result && result.data;
        const summaryData = resultData && resultData.gcsViewCaseSummaryDetailsSecure;
        sessionStorage.setItem(SessionVariables.mepSummaryCaseData, JSON.stringify(summaryData));
        this.service.mepCaseTypeSummaryCase.next(true);
      },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.getMEPSummary(userCode, caseNumber, caseType);
              }
            })
        }
      }
    );
  }

  // MEP-Summary //

  // MEP-Tracking-Order //
  // getMEPOrderTrackStatus
  public getMEPOrderTrackStatus(caseNumber: any, caseType: any): void {
    let getMEPOrderTrackQuery: QueryRef<any>;
    if (!caseNumber && !caseType) {
      const homeCaseNumber = sessionStorage.getItem(SessionVariables.homeCaseNumber) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.mepSubmitCaseData)).caseNumber;
    }

    // console.log('====>',caseType);
    // console.log('====>',caseNumber);
    // caseNumber = 1014934;
    // console.log('====>',caseNumber);
    // let ip = sessionStorage.getItem(SessionVariables.ip);
    // ip = ip ? ip : '';
    // const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    // let screenId = '';
    getMEPOrderTrackQuery = this.apollo.watchQuery({
      query: gql`query MyQuery {
        getMepOrderTracking(input: {OrderId: "${caseNumber}"}) {
          mepNotificationOrderInfo {
            BackOrderQTY
            Carrier_Name
            CarrierRouting
            Carrier_URL
            Concat_Tracking_No
            Description
            LineItemNumber
            ModelCode
            OrderQTY
            TrackingNumber
            finalShipDate
          }
        }
      }
       `,
    });

    getMEPOrderTrackQuery.valueChanges.subscribe(
      (result) => {

        const resultData = result && result.data;
        // console.log(resultData);

        const orderData = resultData && resultData.getMepOrderTracking.mepNotificationOrderInfo;
        // console.log(orderData);
        // console.log(JSON.stringify(orderData));
        sessionStorage.setItem(SessionVariables.mepSummaryOrderData, JSON.stringify(orderData));
        // console.log(sessionStorage.getItem(SessionVariables.mepSummaryOrderData));

        this.service.mepCaseOrderStatus.next(true);
      },
      (err) => {
        const errorMessage = err.message;
        console.log(errorMessage);

        // if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
        //   //code to refresh token and to call again
        //   this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
        //     (result) => {
        //       const data = result.data.renewToken;
        //       if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
        //         // probably should logout the user
        //       } else if (data.JWT) {
        //         sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
        //         const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
        //         updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
        //         updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
        //         updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
        //         updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
        //         sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
        //         this.getMEPSummary(userCode, caseNumber, caseType);
        //       }
        //     })
        // }
      }
    );
  }

  // MEP-Tracking-Order //

  // GEN & MEP-Case-Subscription //
  public getCaseTypeSubscription(userCode: number, caseNumber: any, caseType: any): void {
    let userGenQuery1: QueryRef<any>;
    const getuserCode = userCode || sessionStorage.getItem(SessionVariables.homeUseCode);
    if (!caseNumber && !caseType) {
      const homeCaseNumber = sessionStorage.getItem(SessionVariables.homeCaseNumber) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      if (caseType && caseType === 'GEN') {
        caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData)).caseNumber;
      }
      if (caseType && caseType === 'MEP') {
        caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.mepSubmitCaseData)).caseNumber;
      }
      if (caseType && caseType === 'OSS') {
        caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.ossSubmitCaseData)).caseNumber;
      }
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    userGenQuery1 = this.apollo.watchQuery({
      query: gql`query{
          getCaseSubcriptionsSecure(input:{
            caseTypeCode:"${caseType}",
            caseNumber: ${caseNumber},
            JWT: "${sessionToken}",
            screenId: "${screenId}",
            ipAddress: "${ip}"
          }){
            caseSubscriptionList{
              firstName
              lastName
              localCompany
              userEmail
            }
          }
        }
        `,
    });
    userGenQuery1.valueChanges.subscribe(
      (result1) => {
        const result1Data = result1 && result1.data;

        const summaryData1 = result1Data && result1Data.getCaseSubcriptionsSecure && result1Data.getCaseSubcriptionsSecure.caseSubscriptionList;
        sessionStorage.setItem(SessionVariables.getCaseTypeSubscription, JSON.stringify(summaryData1));
        this.service.getCaseTypeSubscription.next(true);
      },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.getCaseTypeSubscription(userCode, caseNumber, caseType);
              }
            })
        }
      }
    );
  }
  // GEN & MEP-Case-Subscription //

  public genAddCaseSubscription(object: any): any {
    const homeCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.homeCaseNumber)) || null;
    const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
    const getuserCode = sessionStorage.getItem(SessionVariables.homeUseCode);

    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)) || {};
    const createCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData)) || {};

    if (Object.keys(createCaseFirstFormData).length === 0) {
      createCaseFirstFormData.caseType = (homeCaseType && homeCaseType.trim());
    }

    if (Object.keys(createCaseNumber).length === 0) {
      // tslint:disable-next-line: radix
      createCaseNumber.caseNumber = homeCaseNumber;
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    this.apollo.mutate({
      mutation: gql`
      mutation{
        createAndDeleteCaseSubscriptionSecure(input:{
          JWT:"${sessionToken}",
          screenId:"${screenId}",
          ipAddress: "${ip}",
          caseTypeCode: "${createCaseFirstFormData.caseType}",
          caseNumber: ${createCaseNumber.caseNumber},
          operation: "${object.operation}",
          userEmail: "${object.email}"
        }){
          message
        }
      }
            `,
    })
      .subscribe(
        data => {
          const resultData = (data && data.data) || {};
          this.service.genAddCaseSubscription.next(true);
        },
        (err) => {
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.genAddCaseSubscription(object);
                }
              })
          }
        }
      );
  }

  public genDeleteCaseSubscription(object: any): any {
    const homeCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.homeCaseNumber)) || null;
    const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
    const getuserCode = sessionStorage.getItem(SessionVariables.homeUseCode);

    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)) || {};
    const createCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData)) || {};

    if (Object.keys(createCaseFirstFormData).length === 0) {
      createCaseFirstFormData.caseType = (homeCaseType && homeCaseType.trim());
    }

    if (Object.keys(createCaseNumber).length === 0) {
      // tslint:disable-next-line: radix
      createCaseNumber.caseNumber = homeCaseNumber;
    }

    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';

    this.apollo.mutate({
      mutation: gql`
      mutation{
        createAndDeleteCaseSubscriptionSecure(input:{
          JWT:"${sessionToken}",
          screenId:"${screenId}",
          ipAddress: "${ip}",
          caseTypeCode: "${createCaseFirstFormData.caseType}",
          caseNumber: ${createCaseNumber.caseNumber},
          operation: "${object.operation}",
          userEmail: "${object.email}"
        }){
          message
        }
      }
        `,
    })
      .subscribe(
        data => {
          const resultData = (data && data.data) || {};
          this.service.genDeleteCaseSubscription.next(true);
        },
        (err) => {
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.genDeleteCaseSubscription(object);
                }
              })
          }

        }
      );
  }
  // GEN-Case-Subscription //
  /* TEC and PER CASE SUBMIT*/
  public terOrPerSubmitCase(valueObject: any): void {
    this.service.WritelogToCloudWatch(valueObject)
    debugger;
    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm));
    const TECsubjectProductForm = JSON.parse(sessionStorage.getItem(SessionVariables.TECsubjectProductForm));
    const loggedIDetails = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const getALLTecPerData = JSON.parse(sessionStorage.getItem(SessionVariables.getTECPERData));

    let getAllContacts = [];
    for (const obj of getALLTecPerData) {
      if (obj.paAccountName === sessionStorage.getItem(SessionVariables.selectedCompany)) {
        getAllContacts = obj.paContacts;
      }
    }
    const commercialReference = sessionStorage.getItem(SessionVariables.selectedCommercialReference);
    const siteValue = sessionStorage.getItem(SessionVariables.selectedSiteId) || null;
    var selectedSiteId = (siteValue !== 'undefined' &&  siteValue !== null)? `"${siteValue}"` : null;


    const loggedData: any = loggedIDetails.data;
    const loggedUserInfo = loggedData.getLoggedInUserInfo;
    //let contactDetails: any;
    const contactDetails = JSON.parse(sessionStorage.getItem(SessionVariables.selectedContactDetails));

    valueObject.customerRequest = valueObject && valueObject.customerRequest.split('\\\n').join('<br>').split('\n').join('<br>');
    // valueObject.subject = valueObject && valueObject.subject.replace(/[\']/g, "''");
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = screenIdsForTelemetry['case-management-create-case'].screenId;

    let cvcpId = contactDetails?.paContactCvcpId ?? ""
    let paContactId =contactDetails?.paContactId?? ""
    // let obj={
    //   caseTypeCode: createCaseFirstFormData.caseType,
    //   subject: valueObject.subject,
    //   customerRequest: valueObject.customerRequest,
    //   cvcpId: contactDetails.paContactCvcpId,
    //   commercialReference: commercialReference,
    //   priority: valueObject.priority,
    //   paCaseType: valueObject.paCaseType,
    //   paCustomerInternalCaseNumber: createCaseFirstFormData.customerref,
    //   alarmDateAndTime: createCaseFirstFormData.dateoccurred,
    //   paSiteId: selectedSiteId,
    //   contactId: contactDetails.paContactId,
    //   JWT: sessionToken,
    //   screenId: screenId,
    //   ipAddress: ip,
    // }

    // let stringfyObj= JSON.stringify(obj)

    this.apollo.mutate({
      mutation: gql`
      mutation{
        bfoCreateCase(input:{
          caseTypeCode:"${createCaseFirstFormData.caseType}",
          subject: "${valueObject.subject}",
          customerRequest: "${valueObject.customerRequest}",
          cvcpId: "${cvcpId}",
          commercialReference: "${commercialReference}",
          priority: "${valueObject.priority}",
          paCaseType: "${valueObject.paCaseType}",
          paCustomerInternalCaseNumber: "${createCaseFirstFormData.customerref}",
          alarmDateAndTime: "${createCaseFirstFormData.dateoccurred}",
          paSiteId: ${selectedSiteId},
          contactId: "${paContactId}",
          JWT: "${sessionToken}",
          screenId: "${screenId}",
          ipAddress: "${ip}",
        }){
          bfoApiUrl
          bfoErrorMsg
          bfoStatusCode
          caseNumber
          caseId
          bfoApiPayload
        }
      }
 `,
    })
      .subscribe(
        (result) => {

          this.service.WritelogToCloudWatch("case submitted successfully",result)
          const getData: any = result && result.data || {};
          let createCaseData = getData?.bfoCreateCase;
          //createCaseData.bfoStatusCode = "500";
          if (createCaseData.bfoStatusCode == "200" || createCaseData.bfoStatusCode == "201") {
            sessionStorage.setItem(SessionVariables.TecOrPerSubmitCaseData, JSON.stringify(getData && getData.bfoCreateCase));
            this.service.tecPerCaseTypeSubmitCase.next(true);
          } else {
            const userCode = this.service.getIds();
            let userMsg = JSON.parse(createCaseData.bfoErrorMsg.replace(/\r?\n|\r/g, '')) || {};
            this.httpClient.get(environment.errorBfoJson).subscribe((data: Array<any>) => {


              //let userMsg = JSON.parse(createCaseData.bfoErrorMsg) || {};


              let errorDataList = data.filter((errorItem) => {
                if (errorItem.API_URL === createCaseData.bfoApiUrl
                  && errorItem.API_Error_Code === userMsg.code
                  && errorItem.HTTP_Code === createCaseData.bfoStatusCode) {
                  return errorItem;
                }
              });
              if (errorDataList.length !== 0) {
                let errdetails = errorDataList[0];
                this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", errdetails.HTTP_Code, errdetails.API_Error_Code,
                  errdetails.API_URL, errdetails.API_Error_Type, errdetails.API_UserMessage, userMsg.developerMessage,
                  (createCaseData.bfoApiPayload && createCaseData.bfoApiPayload.replace(/['"]+/g, '').replace(/[\\]/g, '')));
              }
              else {
                this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", createCaseData.bfoStatusCode, userMsg.code,
                  createCaseData.bfoApiUrl, "", userMsg.userMessage, userMsg.developerMessage,
                  (createCaseData.bfoApiPayload && createCaseData.bfoApiPayload.replace(/['"]+/g, '').replace(/[\\]/g, '')));
              }
              debugger;
              this.service.errorLogHandling.next({
                userCode: userCode.user_code,
                LogText: "API Event",
                SourceApp: "GCSWeb2020",
                API_HTTP_Code: (errorDataList.length !== 0) ? errorDataList[0].HTTP_Code : createCaseData.bfoStatusCode,
                API_Error_Code: (errorDataList.length !== 0) ? errorDataList[0].API_Error_Code : userMsg.code,
                API_URL: (errorDataList.length !== 0) ? errorDataList[0].API_URL : "",
                API_Error_Type: (errorDataList.length !== 0) ? errorDataList[0].API_URL : "",
                API_UserMessage: (errorDataList.length !== 0) ? errorDataList[0].API_UserMessage : userMsg.userMessage,
                API_DevMessage: userMsg.developerMessage,
                API_Data: (createCaseData.bfoApiPayload && createCaseData.bfoApiPayload.replace(/['"]+/g, '').replace(/[\\]/g, ''))
              });

            })

          }
          ////should raise event here
          //this.service.tecPerCaseTypeSubmitCase.next(true);
        },
        (err) => {

          this.service.WritelogToCloudWatch(err)
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.terOrPerSubmitCase(valueObject);
                }
              })
          }
          else {
            //should be handled
            // this.service.tecPerCaseTypeSubmitCase.next(true);
            debugger;
            console.log(err)
            const userCode = this.service.getIds();

            this.service.errorLogHandling.next({
              userCode: userCode.user_code,
              LogText: "terOrPerSubmitCase",
              SourceApp: "GCSWeb2020",
              API_HTTP_Code: "5000",
              API_Error_Code: "5000",
              API_URL: "",
              API_Error_Type: err.name,
              API_UserMessage: "Unable to Submit Form: Please contact local support for assistance.",
              API_DevMessage: err.message,
              API_Data: ''
            });

          }
        }
      );
  }

  public tecPerRequestCaseClosure(comment: string): void {
    const loggedUser = this.service.getIds();
    const caseId = JSON.parse(sessionStorage.getItem(SessionVariables.TecOrPerSubmitCaseData));

    const homeCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.homeCaseNumber)) || null;

    const caseNumberBoth = sessionStorage.getItem(SessionVariables.homeCaseId) || caseId.caseId;
    const commentBody = comment || `Your Request for Case Closure has been sent`;
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    const screenId = screenIdsForTelemetry['case-summary'].screenId;
    this.apollo.mutate({
      mutation: gql`
      mutation{
        bfoPostComment(input:{
          caseId:"${caseNumberBoth}",
          commentBody:"${commentBody}",
          JWT: "${sessionToken}",
          screenId: "${screenId}",
          ipAddress: "${ip}"
        }){
          commentId
        }
      }
            `,
    })
      .subscribe(
        data => {
          const resultData = (data && data.data) || {};
          this.service.tecPerRequestCaseClosure.next(true);
        },
        (err) => {
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.tecPerRequestCaseClosure(comment);
                }
              })
          }
        }
      );
  }


  // tec per case type get BFO comments
  public getTecPerComments(): void {
    let getComments: QueryRef<any>;
    const loggedUser = this.service.getIds();
    const createCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.TecOrPerSubmitCaseData));
    const homeCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.tecSummaryCaseData)) || null;
    const caseNumberBoth = sessionStorage.getItem(SessionVariables.homeCaseId) || createCaseNumber.caseId;
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = screenIdsForTelemetry['case-summary'];
    getComments = this.apollo.watchQuery({
      query: gql`
      query{
        bfoGetComments(input:{
          caseId:"${caseNumberBoth}",
          JWT: "${sessionToken}"
          screenId: "${screenId}",
          ipAddress: "${ip}"
        }){
          bfoStatusCode
          bfoGetCommentList{
            commentBody
            createdDate
            createdByName
            createdById
            isPublic
          }
          bfoApiPayload
          bfoApiUrl
          bfoErrorMsg
        }
      }
    `,
      fetchPolicy: 'network-only'
    });
    getComments.valueChanges.subscribe(
      (data) => {
        const resultData = data && data.data;
        const allComments = resultData && resultData.bfoGetComments;
        if (allComments && allComments.bfoStatusCode == 200) {
          sessionStorage.setItem(SessionVariables.getTecPerComments, JSON.stringify(allComments.bfoGetCommentList));
          this.service.tecPerGetComments.next(true);
        } else {
          this.httpClient.get(environment.errorBfoJson).subscribe((data: Array<any>) => {

            let userMsg = JSON.parse(allComments.bfoErrorMsg) || {};
            const userCode = this.service.getIds();

            let errorDataList = data.filter((errorItem) => {
              if (errorItem.API_URL === allComments.bfoApiUrl
                && errorItem.API_Error_Code === userMsg.code
                && errorItem.HTTP_Code === allComments.bfoStatusCode) {
                return errorItem;
              }
            });
            if (errorDataList.length !== 0) {
              let errdetails = errorDataList[0];
              this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", errdetails.HTTP_Code, errdetails.API_Error_Code,
                errdetails.API_URL, errdetails.API_Error_Type, errdetails.API_UserMessage, userMsg.developerMessage, (allComments.bfoApiPayload && allComments.bfoApiPayload.replace(/['"]+/g, '')));
            }
            else {
              this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", allComments.bfoStatusCode, userMsg.code,
                allComments.bfoApiUrl, "", userMsg.userMessage, userMsg.developerMessage, (allComments.bfoApiPayload && allComments.bfoApiPayload.replace(/['"]+/g, '')));
            }

          })
        }
      },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.getTecPerComments();
              }
            })
        }
      }
    );
  }

  public addTECPERComment(selectedValue: string): void {
    const loggedUser = this.service.getIds();
    const createCaseNumber = JSON.parse(sessionStorage.getItem(SessionVariables.TecOrPerSubmitCaseData)) || {};
    const caseNumberBoth = sessionStorage.getItem(SessionVariables.homeCaseId) || createCaseNumber.caseId;
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';
    let publicFlag = true;
    this.apollo.mutate({
      mutation: gql`
            mutation{
              bfoPostComment(input:{
                caseId:"${caseNumberBoth}",
                commentBody:"${selectedValue}",
                JWT: "${sessionToken}",
                screenId: "${screenId}",
                ipAddress: "${ip}",
                isPublic: ${publicFlag}
              }){
                bfoApiPayload
                bfoApiUrl
                bfoErrorMsg
                bfoStatusCode
                commentId
              }
            }
            `,
    }).subscribe((data: any) => {
      const resultData = data && data.data;
      const commentData = resultData && resultData.bfoPostComment;
      if (commentData && commentData.bfoStatusCode !== 200 && commentData.bfoStatusCode !== 201) {
        this.httpClient.get(environment.errorBfoJson).subscribe((data: Array<any>) => {

          let userMsg = JSON.parse(commentData.bfoErrorMsg) || {};
          const userCode = this.service.getIds();

          let errorDataList = data.filter((errorItem) => {
            if (errorItem.API_URL === commentData.bfoApiUrl
              && errorItem.API_Error_Code === userMsg.code
              && errorItem.HTTP_Code === commentData.bfoStatusCode) {
              return errorItem;
            }
          });
          if (errorDataList.length !== 0) {
            let errdetails = errorDataList[0];
            this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", errdetails.HTTP_Code, errdetails.API_Error_Code,
              errdetails.API_URL, errdetails.API_Error_Type, errdetails.API_UserMessage, userMsg.developerMessage, (commentData.bfoApiPayload && commentData.bfoApiPayload.replace(/['"]+/g, '')));
          }
          else {
            this.gcsGraphQlsetbBfoLogsServiceSecure.setBfoLog(userCode.user_code, "API Event", "GCSWeb2020", commentData.bfoStatusCode, userMsg.code,
              commentData.bfoApiUrl, "", userMsg.userMessage, userMsg.developerMessage, (commentData.bfoApiPayload && commentData.bfoApiPayload.replace(/['"]+/g, '')));
          }
        })
      } else {
        this.service.getTECPERCommentAdd.next(true);
      }
    },
      (err) => {
        const errorMessage = err.message;
        if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
          //code to refresh token and to call again
          this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
            (result) => {
              const data = result.data.renewToken;
              if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                // probably should logout the user
              } else if (data.JWT) {
                sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                this.addTECPERComment(selectedValue);
              }
            })
        }
      }
    );
  }

  public getGCSDownloadTo(UploadId: string, fileName: any, filetype: any, caseNumber: any): any {
    const loggedUser = this.service.getIds();
    const federatedId = loggedUser.federatedId


    const jwt = loggedUser.JWT;
    const accessToken = loggedUser.accessToken;
    // const getDownloadQL = JSON.parse(sessionStorage.getItem(SessionVariables.getCompanies));
    let downloadQueryValue: QueryRef<any>;
    downloadQueryValue = this.apollo.watchQuery({
      query: gql`
     query{
      downloadCaseFile(input: {   JWT: "${jwt}",
      accessToken: "${accessToken}",
      caseNumber: "${caseNumber}",
      federatedId: "${federatedId}",
      UploadId: "${UploadId}",
      filename: "${fileName}"})



    }
   `,
    });
    downloadQueryValue.valueChanges.subscribe((result) => {

      filetype = fileName.split(".")[1] || ".png"
      const downloadBlob = result.data.downloadCaseFile.split("=")[1].replace('}','').replace('{',"") //&& result.data && result.data.bfoDownloadFile && result.data.bfoDownloadFile.fileContent;

      const downloadURL = window.URL.createObjectURL(this.b64toBlob(downloadBlob, filetype));
      // const downloadURL = window.URL.createObjectURL(new Blob([downloadBlob], { type: `text/${filetype}` }));
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = fileName ///+ '.' + filetype;
      link.click();
      this.service.getGCSDownloadTo.next(true);
    });
  }

  private b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    try {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;

    } catch (error) {

      console.error(error)
    }

  }

  public genListCaseUploads(caseNumber: String) {
    debugger;
    const loggedUser = this.service.getIds();
    //const genSubmitInfo = JSON.parse(sessionStorage.getItem(SessionVariables.genSubmitCaseData));

    const federatedId = loggedUser.federatedId
    //const caseNumber =genSubmitInfo.caseNumber



    const jwt = loggedUser.JWT;
    const accessToken = loggedUser.accessToken;
    let listUploadedFilesResult: QueryRef<any>;
    listUploadedFilesResult = this.apollo.watchQuery({
      query: gql`
    query {
      listCaseUploads(input: {
      JWT: "${jwt}",
      accessToken: "${accessToken}",
      caseNumber: "${caseNumber}",
      federatedId: "${federatedId}"}) {
    Files{
      Date
      FileBytes
      FileName
      UploadId
      UploadedBy
    }
  }
    }`,
    })
    listUploadedFilesResult.valueChanges.subscribe(data => {

      this.service.genGetUploadList.next(data);
    }, (err) => {

      console.log(err)
    });


  }

  public genPostFile(image: any, caseNumber: string): void {
    //TODO
    //still not tested
    debugger;
    const loggedUser = this.service.getIds();

    // console.log(image);

    //const options ={
    const federatedId = loggedUser.federatedId;
    // const caseNumber = caseNumber;
    const fileName = image[0].fileType;
    const f = image[0].src;

    //  }
    const jwt = loggedUser.JWT;
    const accessToken = loggedUser.accessToken;

    let genPostFileQuery: QueryRef<any>;
    genPostFileQuery = this.apollo.watchQuery({
      query: gql`
      query{
        uploadCaseFile(input:{
          fileName:"${fileName}",
          federatedId:"${federatedId}",
          f:"${f}",
          caseNumber:"${caseNumber}",
          accessToken:"${accessToken}",
          JWT: "${jwt}"
        }){
          gcs_error,
          info,
          success,
          uploadId
          }
      }`,
    })
    genPostFileQuery.valueChanges.subscribe(data => {
      // console.log(data)
      this.service.genCaseFileupload.next(data);
    }, (err) => {

      console.error(err)
    });



  }
  public tecPerPostFile(image: any): void {
    debugger;
    const loggedUser = this.service.getIds();
    const tecOrPerSubmitInfo = JSON.parse(sessionStorage.getItem(SessionVariables.TecOrPerSubmitCaseData));
    let formattedAttachments = '';
    const tecOrPerupdateFileData = image;
    tecOrPerupdateFileData.map(attachment => {
      formattedAttachments += `{ description: "${attachment.fileName}", pathOnClient: "${attachment.fileType}", versionData: "${attachment.src}" }`;
    });
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = screenIdsForTelemetry['case-summary'].screenId;

    this.apollo.mutate({
      mutation: gql`
      mutation{
        bfoPostFile(input:{
          networkId:"0DB12000000KyopGAC",
          caseId: "${tecOrPerSubmitInfo.caseId}",
          firstPublishLocationId:"${tecOrPerSubmitInfo.caseId}",
          fileDetails: [${formattedAttachments}],
          screenId: "${screenId}",
          JWT: "${sessionToken}",
          ipAddress: "${ip}"
        }){
          bfoPostFileList{
            id
            success
            errors
            bfoApiPayload
            bfoApiUrl
            bfoErrorMsg
            bfoStatusCode
          }
        }
      }`,
    })
      .subscribe(data => {
        this.service.tecPerCaseFileupload.next(true);
      },(err)=>{
        console.log(err);
      });
  }

  // MEP case type submit case
  public mepCaseSubmit(): void {
    debugger;

    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm));
    // MEP forms data
    const mepProductRequestInfo = JSON.parse(sessionStorage.getItem(SessionVariables.mepProductRequestInfo));
    const mepPartsData = JSON.parse(sessionStorage.getItem(SessionVariables.mepPartsGridData));
    const mepShippingData = JSON.parse(sessionStorage.getItem(SessionVariables.mepShippingBillingDetails));
    const contaminationData = JSON.parse(sessionStorage.getItem(SessionVariables.mepContaminationInfoDetails));
    const mepProductDataConfirm = JSON.parse(sessionStorage.getItem(SessionVariables.mepProductDataConfirm));
    const selectedCompany = sessionStorage.getItem(SessionVariables.selectedCompany) || null;
    const siteSelected = sessionStorage.getItem(SessionVariables.selectedSite) || null;
    const prioritySelected = sessionStorage.getItem(SessionVariables.selectedPriority) || null;

    const loggedIDetails = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const getAllContacts = JSON.parse(sessionStorage.getItem(SessionVariables.getContacts));
    const selected_sap_Contract=JSON.parse(sessionStorage.getItem(SessionVariables.selectedContract));
    var contractTypeValue =selected_sap_Contract?.contractTypeValue
    const loggedData: any = loggedIDetails.data;
    const loggedUserInfo = loggedData.getLoggedInUserInfo;
    let contactDetails: any;
    let isContactFind = false;
    for (const item of getAllContacts) {
      const name = `${item.firstName} ${item.lastName}`;
      const itemCFID = parseInt(item.customerContactNumber, 10);
      if (name === createCaseFirstFormData.contact) {
        contactDetails = item;
        isContactFind = true;
        break;
      } else if (loggedUserInfo.CFIDList && loggedUserInfo.CFIDList.includes(itemCFID)) {
        contactDetails = item;
        isContactFind = true;
        break;
      }
    }
    if (!isContactFind) {
      const loggedName = `${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`;
      if (createCaseFirstFormData.contact === loggedName) {
        const loggedObject = {
          phone: loggedUserInfo.workPhone,
          email: loggedUserInfo.email,
          customerContactNumber: loggedUserInfo.CFID
        };
        contactDetails = loggedObject;
      }
    }
    const siteGuid = createCaseFirstFormData.site ? `"{${createCaseFirstFormData.site}}"` : null;

    let brandProductCode: any=null;
    let hardwareCode: any =-1;
    if(sessionStorage.getItem(SessionVariables.getProduct)){
      for (const item of JSON.parse(sessionStorage.getItem(SessionVariables.getProduct))) {
        if (item.prodTypeCode === mepProductRequestInfo.PRODUCT) {
          brandProductCode = item.brandProductCode;
        }
      }
    }
    else if (sessionStorage.getItem(SessionVariables.mepBrandProductCode)) {
      brandProductCode = JSON.parse(sessionStorage.getItem(SessionVariables.mepBrandProductCode));
    }
    else {

    }

    const firstName = loggedUserInfo.firstName || '';
    const middleName = loggedUserInfo.middleName || '';
    const lastName = loggedUserInfo.lastName || '';
    const submitterUserName = `${firstName} ${middleName} ${lastName}`;
    const submitterPhone = loggedUserInfo.workPhone || '';
    const phone = contactDetails.phone || '';

    const contract = mepProductRequestInfo && mepProductRequestInfo.CONTRACT === 'Yes' ? 1 : 0;
    const processDown = mepProductRequestInfo && mepProductRequestInfo.PROCESS_DOWN === 'Yes' ? 1 : 0;
    const warranty = mepProductRequestInfo && mepProductRequestInfo.WARRANTY === 'Yes' ? 1 : 0;
    const criticalRadio = contaminationData && contaminationData.criticalRadio === 'Yes' ? 1 : 0;
    const processWetted = contaminationData && contaminationData.preApproval === 'Yes' ? 1 : 0;
debugger
    let partsStringArray = '';
    mepPartsData.map(attachment => {
      let style_rev = attachment.STYLE_REVISION ? `"${this.service.escape(attachment.STYLE_REVISION)}"`:null;
      let serialNumber = attachment.SERIAL_NUMBER ? `"${this.service.escape(attachment.SERIAL_NUMBER)}"`:null;
      let PART_DESCRIPTION = this.service.escape(attachment.PART_DESCRIPTION);
      let build = attachment.build;
      if (build) {
        build = this.service.escape(attachment.build);
      }
      partsStringArray += `{ partNumber: "${attachment.PART_NUMBER}", quantity: 1, serialNumber: ${serialNumber}, rev: ${style_rev}, description: "${PART_DESCRIPTION}", failureType: "${attachment.FAILURE_TYPE_Code}", serviceTime: ${attachment.DAYS_IN_SERVICE}, build: "${build}" }`;
    });
    // partsStringArray = `[${partsStringArray}]`;
    const poDate = mepProductRequestInfo.PO_DATE === null ? "" : mepProductRequestInfo.PO_DATE;
    const warrantyEndDate = mepProductRequestInfo.WARRANTY_END_DATE === null ? "" : mepProductRequestInfo.WARRANTY_END_DATE;
    const deliveryDate = mepProductRequestInfo && mepProductRequestInfo.DELIVERY_DATE ? mepProductRequestInfo.DELIVERY_DATE : "";
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';

    let emailDescription: string;
    let emailConfiguration: string;
    if (mepProductRequestInfo && mepProductRequestInfo.DESCRIPTION) {
      let checkDesc = mepProductRequestInfo.DESCRIPTION;
      checkDesc = checkDesc.replaceAll('\'', "''");
      checkDesc = checkDesc.replaceAll('\"', "''");
      mepProductRequestInfo.DESCRIPTION = checkDesc.trim();
      emailDescription = checkDesc.replaceAll('\n', '<br/>');
    }
    if (mepProductRequestInfo && mepProductRequestInfo.CONFIGURATION && mepProductRequestInfo.CONFIGURATION !== '') {
      let checkConfig = mepProductRequestInfo.CONFIGURATION;
      checkConfig = checkConfig.replaceAll('\'', "''");
      checkConfig = checkConfig.replaceAll('\"', "''");
      mepProductRequestInfo.CONFIGURATION = `""${checkConfig.trim()}""`;
      emailConfiguration = checkConfig.replaceAll('\n', '<br/>');
    }
    else if (mepProductRequestInfo.CONFIGURATION === null || mepProductRequestInfo.CONFIGURATION === '' || mepProductRequestInfo.CONFIGURATION === undefined) {
      emailConfiguration = '-';
    }

    if (mepProductDataConfirm && mepProductDataConfirm?.REPRODUCIBLE) {
      let checkReprod = mepProductDataConfirm.REPRODUCIBLE;
      checkReprod = checkReprod.replaceAll('\'', "''");
      mepProductDataConfirm.REPRODUCIBLE = checkReprod.trim();
    }

    // productFamily: "${mepProductDataConfirm.PRODUCT_FAMILY}",
    // productGroup: "${mepProductDataConfirm.PRODUCT_GROUP}",
    // product: "${mepProductDataConfirm.PRODUCT}",
    // productVersion: "${mepProductDataConfirm.PRODUCT_VERSION}",

    // area: "${mepProductDataConfirm.AREA}",
    // reproducible: "${mepProductDataConfirm.REPRODUCIBLE}",
   const PRODUCT_FAMILY = mepProductDataConfirm?.PRODUCT_FAMILY ? mepProductDataConfirm?.PRODUCT_FAMILY :-1
   const PRODUCT_GROUP =mepProductDataConfirm?.PRODUCT_GROUP ?mepProductDataConfirm?.PRODUCT_GROUP :-1
   const PRODUCT =mepProductDataConfirm?.PRODUCT ? mepProductDataConfirm?.PRODUCT :-1;
   const PRODUCT_VERSION =mepProductDataConfirm?.PRODUCT_VERSION? mepProductDataConfirm?.PRODUCT_VERSION: -1
   const AREA =mepProductDataConfirm?.AREA? mepProductDataConfirm.AREA :-1

   let specialInstructions;
   if (mepShippingData.special) {
    specialInstructions = this.service.escape(mepShippingData.special);
   } else {
    specialInstructions = mepShippingData.special;
   }
   let criticalInput;
   if (contaminationData.criticalInput) {
    criticalInput = this.service.escape(contaminationData.criticalInput);
   } else {
    criticalInput = contaminationData.criticalInput;
   }

   const REPRODUCIBLE =mepProductDataConfirm?.REPRODUCIBLE ?mepProductDataConfirm.REPRODUCIBLE :-1
   const versionCode= mepProductRequestInfo?.PRODUCT_VERSION?mepProductRequestInfo?.PRODUCT_VERSION:-1

   const locationCode =mepProductRequestInfo?.AREA?mepProductRequestInfo?.AREA :-1;
   const reproducibleCode= mepProductRequestInfo?.REPRODUCIBLE?mepProductRequestInfo?.REPRODUCIBLE :-1



    let emailDateOccured: any;
    let emailPoDate: any;
    let emailWarrantyEndDate: any;
    let emailsiteSelected = (siteSelected === null || siteSelected === '' || siteSelected === undefined) ? '-' : siteSelected;
    let emailmepCustRef = (createCaseFirstFormData.customerref === null || createCaseFirstFormData.customerref === '' || createCaseFirstFormData.customerref === undefined) ? '-' : createCaseFirstFormData.customerref;



    let emailmepmepOriginalSales = (mepShippingData.originalSales === null || mepShippingData.originalSales === '' || mepShippingData.originalSales === undefined) ? '-' : mepShippingData.originalSales;

    let emailmepPo_number = (mepProductRequestInfo.PO_NUMBER === null || mepProductRequestInfo.PO_NUMBER === '' || mepProductRequestInfo.PO_NUMBER === undefined) ? '-' : mepProductRequestInfo.PO_NUMBER;

    let emailmepmepSpecial = (mepShippingData.special === null || mepShippingData.special === '' || mepShippingData.special === undefined) ? '-' : mepShippingData.special;



    let emailmepmepChemicals = (contaminationData.chemicals === null || contaminationData.chemicals === '' || contaminationData.chemicals === undefined) ? '-' : contaminationData.chemicals;

    let emailmepmepDecontaminate = (contaminationData.decontaminate === null || contaminationData.decontaminate === ''
      || contaminationData.decontaminate === undefined) ? '-' : contaminationData.decontaminate;


    if (createCaseFirstFormData && createCaseFirstFormData.dateoccurred) {
      let splitDate: any;
      if (createCaseFirstFormData.dateoccurred.includes('T')) {
        splitDate = createCaseFirstFormData.dateoccurred.split('T');
        emailDateOccured = splitDate && splitDate[0];
      } else {
        emailDateOccured = createCaseFirstFormData.dateoccurred;
      }
    }

    if (mepProductRequestInfo && mepProductRequestInfo.PO_DATE) {
      let splitDate: any;
      if (mepProductRequestInfo.PO_DATE.includes('T')) {
        splitDate = mepProductRequestInfo.PO_DATE.split('T');
        emailPoDate = splitDate && splitDate[0];
      } else {
        emailPoDate = mepProductRequestInfo.PO_DATE || '-';
      }
    }
    else if (mepProductRequestInfo.PO_DATE === null || mepProductRequestInfo.PO_DATE === '' || mepProductRequestInfo.PO_DATE === undefined) {
      emailPoDate = '-';

    }

    if (mepProductRequestInfo && mepProductRequestInfo.WARRANTY_END_DATE) {
      let splitDate: any;
      if (mepProductRequestInfo.WARRANTY_END_DATE.includes('T')) {
        splitDate = mepProductRequestInfo.WARRANTY_END_DATE.split('T');
        emailWarrantyEndDate = splitDate && splitDate[0];
      } else {
        emailWarrantyEndDate = mepProductRequestInfo.WARRANTY_END_DATE || '-';
      }
    }
    else if (mepProductRequestInfo.WARRANTY_END_DATE === null || mepProductRequestInfo.WARRANTY_END_DATE === '' || mepProductRequestInfo.WARRANTY_END_DATE === undefined) {
      emailWarrantyEndDate = '-';

    }

    this.apollo.mutate({
      mutation: gql`
      mutation{
        gcsCreateCaseSecure(input:{
            caseTypeCode:"${createCaseFirstFormData.caseType}",
            carNumber:null,
            localCompanyCode:${createCaseFirstFormData.company},
            siteGuid:${siteGuid},
            contactFullName:"${createCaseFirstFormData.contact}",
            contactId:"${contactDetails.customerContactNumber}",
            phone:"${phone}",
            email:"${contactDetails.email}",
            SEContactName:"",
            SEConactPhone:"",
            SEContactEmail:"",
            submitterFullName:"${submitterUserName}",
            submitterPhone:"${submitterPhone}",
            submitterEmail:"${loggedUserInfo.email}",
            dateOccured:"${createCaseFirstFormData.dateoccurred}",
            locationCode:"${locationCode}",
            reproducibleCode:"${reproducibleCode}",
            impactCode:"${createCaseFirstFormData.priority}",
            issueType:"",
            brandProductCode: ${brandProductCode},
            hardwareCode: "${hardwareCode}",
            versionCode:"${versionCode}",
            customerRefField:"${createCaseFirstFormData.customerref}",
            configurationInput:"${mepProductRequestInfo.CONFIGURATION}",
            descriptionInput:"""${mepProductRequestInfo.DESCRIPTION}""", #here
            suggestedSolution:"Test Suggested Solution",
            benefitText:"Test Benefit Input",
            CRUserId:"",
            RMACode:"",
            carTypeCode:1,
            caseType:"${createCaseFirstFormData.caseType}",
            salesOrderNumber:"${mepShippingData.originalSales}",
            serviceOrderNumber:"",
            SAFEffect:"I",
            PONumber:"${mepProductRequestInfo.PO_NUMBER}", #here
            POEndDate:"${poDate}",
            webCode:null,
            newCaseGUID:null,
            qualCode:"",
            goldenID:"",
            requestType:"${mepProductRequestInfo.REQUEST_TYPE}",
            contract: ${contract},
            warranty: ${warranty},
            warrantyExpires:"${warrantyEndDate}",
            processDown: ${processDown},
            softwareVersion:"",
            contamination: ${criticalRadio},
            exposedTo:"${criticalInput}", #here
            specialInstructions:"${specialInstructions}", #here
            processWetted:${processWetted},
            processType:"${contaminationData.chemicals}",
            decontaminateSteps:"${contaminationData.decontaminate}",
            shipToInfo:"${mepShippingData.shipTo}",
            billToInfo:"${mepShippingData.billTo}",
            reqDelivDate:"${deliveryDate}",
            partsDetails: [${partsStringArray}], #here
            company: "${selectedCompany}",
            site: "${siteSelected}",
            productFamily: "${PRODUCT_FAMILY}",
            productGroup: "${PRODUCT_GROUP}",
            product: "${PRODUCT}",
            productVersion: "${PRODUCT_VERSION}",
            priority: "${prioritySelected}",
            area: "${AREA}",
            reproducible: "${REPRODUCIBLE}",
            JWT: "${sessionToken}",
            screenId: "${screenId}",
            ipAddress: "${ip}",
            sapContract:"${contractTypeValue}"
        }) {
          caseNumber
          message
        }
      }
 `,
    })
      .subscribe(
        data => {
         debugger
          this.service.WritelogToCloudWatch("case submitted successfully",data)
          const getData: any = (data && data.data) || {};
          sessionStorage.setItem(SessionVariables.mepSubmitCaseData, JSON.stringify(getData && getData.gcsCreateCaseSecure));
          this.service.mepSubmitCase.next(true);
          let innerbody = '';
          mepPartsData.forEach((part) => {
            let allTrs = '';
            // Object.entries(part).forEach((value) => {
            //   if (value && value[0] !== 'failureTypeDesc' && value[0] !== 'partCreateDate' && value[0] !== 'partModifyDate' && value[0] !== 'quantity' && (value && value[0] !== '__typename')) {
            //     const td = `<td>${value && value[1]}</td>`;
            //     allTrs += `${td}`;
            //   }
            // });
            const td_description = part.PART_DESCRIPTION ? `<td>${part.PART_DESCRIPTION}</td>` : `<td>null</td>`;
            allTrs += `${td_description}`;
            const td_failuretype = `<td>${part.FAILURE_TYPE}</td>`;
            allTrs += `${td_failuretype}`;
            const td_number = `<td>${part.PART_NUMBER}</td>`;
            allTrs += `${td_number}`;
            const td_style = `<td>${this.service.escapeSpecialCharacters(part.STYLE_REVISION)}</td>`;
            allTrs += `${td_style}`;
            const td_serial = `<td>${this.service.escapeSpecialCharacters(part.SERIAL_NUMBER)}</td>`;
            allTrs += `${td_serial}`;
            const td_days = `<td>${part.DAYS_IN_SERVICE}</td>`;
            allTrs += `${td_days}`;
            const td_build = `<td>${this.service.escapeSpecialCharacters(part.build)}</td>`;
            allTrs += `${td_build}`;
            innerbody += `<tr>${allTrs}</tr>`;
          });
          const mepShipping = JSON.parse(sessionStorage.getItem(SessionVariables.mepShippingBillingConfirm));
          const emailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div>Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br/> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailsiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Request Type :</b></span> <span class=''value''>${mepProductRequestInfo.REQUEST_TYPE}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailmepCustRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Process Down :</b></span> <span class=''value''>${mepProductRequestInfo.PROCESS_DOWN}</span></div><div> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${mepProductDataConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${mepProductDataConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfiguration}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${emailDescription}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailmepPo_number}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${mepProductRequestInfo.WARRANTY}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${mepProductRequestInfo.CONTRACT}</span></div></div></div><div class=''parts-table''><h3>Parts Details</h3><table id=''parts''><thead><tr><th>Part Description</th><th>Failure Type</th><th>Part Number</th><th>Style/Revision</th><th>Serial Number</th><th>Days in Service</th><th>Build</th></tr></thead><tbody id=''t-body''> ${innerbody}</tbody></table></div><div class=''shpping-info''><h3>Shipping & Billing Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Original Sales Order :</b></span> <span class=''value''>${emailmepmepOriginalSales}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Ship To :</b></span> <span class=''value''>${mepShipping.shipTo}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Bill to :</b></span> <span class=''value''>${mepShipping.billTo}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Special Instructions :</b></span> <span class=''value''>${emailmepmepSpecial}</span></div></div></div><div class=''shpping-info''><h3>Contamination Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Contamination :</b></span> <span class=''value''>${contaminationData.criticalRadio}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Process-wetted material :</b></span> <span class=''value''>${contaminationData.preApproval}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Type of Process :</b></span> <span class=''value''>${emailmepmepChemicals}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Decontamination Steps :</b></span> <span class=''value''>
          ${emailmepmepDecontaminate}</span></div></div></div></div></body></html>`;

          const ccEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailsiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Request Type :</b></span> <span class=''value''>${mepProductRequestInfo.REQUEST_TYPE}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailmepCustRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Process Down :</b></span> <span class=''value''>${mepProductRequestInfo.PROCESS_DOWN}</span></div><div> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${mepProductDataConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${mepProductDataConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${mepProductDataConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfiguration}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${emailDescription}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailmepPo_number}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${mepProductRequestInfo.WARRANTY}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${mepProductRequestInfo.CONTRACT}</span></div></div></div><div class=''parts-table''><h3>Parts Details</h3><table id=''parts''><thead><tr><th>Part Description</th><th>Failure Type</th><th>Part Number</th><th>Style/Revision</th><th>Serial Number</th><th>Days in Service</th><th>Build</th></tr></thead><tbody id=''t-body''> ${innerbody}</tbody></table></div><div class=''shpping-info''><h3>Shipping & Billing Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Original Sales Order :</b></span> <span class=''value''>${emailmepmepOriginalSales}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Ship To :</b></span> <span class=''value''>${mepShipping.shipTo}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Bill to :</b></span> <span class=''value''>${mepShipping.billTo}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Special Instructions :</b></span> <span class=''value''>${emailmepmepSpecial}</span></div></div></div><div class=''shpping-info''><h3>Contamination Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Contamination :</b></span> <span class=''value''>${contaminationData.criticalRadio}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Process-wetted material :</b></span> <span class=''value''>${contaminationData.preApproval}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Type of Process :</b></span> <span class=''value''>${emailmepmepChemicals}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Decontamination Steps :</b></span> <span class=''value''>${emailmepmepDecontaminate}</span></div></div></div></div></body></html>`;
          const mepSubmitData = JSON.parse(sessionStorage.getItem(SessionVariables.mepSubmitCaseData)) || null;
        try {
            if (mepSubmitData && mepSubmitData !== undefined && mepSubmitData !== null) {
              this.emailNotification(emailTemp, contactDetails.email, createCaseFirstFormData.company,
                mepSubmitData.caseNumber, ccEmailTemp, emailDescription, 'MEP');
            }
        } catch (error) {
          console.log(error)

        }
        },
        (err) => {
          this.service.WritelogToCloudWatch(err)
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            //code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.mepCaseSubmit();
                }
              })
          }
          else {
            const userCode = this.service.getIds();

            this.service.errorLogHandling.next({
              userCode: userCode.user_code,
              LogText: "mepCaseSubmit",
              SourceApp: "GCSWeb2020",
              API_HTTP_Code: "5000",
              API_Error_Code: "5000",
              API_URL: "",
              API_Error_Type: err.name,
              API_UserMessage: "Unable to Submit Form: Please contact local support for assistance.",
              API_DevMessage: err.stack,
              API_Data: ''
            });

          }
        }
      );
  }

  // Email Template Notification API
  public emailNotification(emailTemp: string, contactEmail: string, companyCode: any, caseNumber: any,
    ccEmailBody: string, description: string, caseType: string): void {
      debugger
    let descFormate: any;
    if (description && description.length > 80) {
      descFormate = description.replace(/\s+/g, ' ').trim();
      descFormate = descFormate.replaceAll('<br/>', '');
      descFormate = descFormate.length > 80 ? descFormate.substring(0, 80) + ('...') : descFormate;
    } else {
      descFormate = description;
    }
    descFormate =this.service.escape(descFormate);

    emailTemp =this.service.escape(emailTemp);
    ccEmailBody = this.service.escape(ccEmailBody);
    const subjectLine = `Schneider Electric Case #${caseNumber}: ${descFormate}`;
    const ccSubjectLine = `CASE ${caseType} Queue Notification: ${caseNumber}`;
    this.apollo.mutate({
      mutation: gql`
            mutation{
              gcsEmailNotification(input:{
                email:"${contactEmail}",
                caseNumber:"${caseNumber}",
                localCompanyCode: ${companyCode},
                emailBody:"${emailTemp}",
                emailBodyForCC: "${ccEmailBody}",
                subject:"${subjectLine}",
                subjectForCC:"${ccSubjectLine}"
              }){
                msg
              }
            }
            `,
    })
      .subscribe(data => {
        // console.log(data);

      },error=>{
        this.service.WritelogToCloudWatch(error)
        console.log(error);
      });
  }

  // OSS submit case
  public ossSubmitCaseMutation(): void {
    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm));
    // OSS forms data
    const ossProductRequestInfo = JSON.parse(sessionStorage.getItem(SessionVariables.ossProductRequestInfo));
    const ossProductRequestInfoConfirm = JSON.parse(sessionStorage.getItem(SessionVariables.ossProductDataConfirm));
    const ossPreventiveMaint = JSON.parse(sessionStorage.getItem(SessionVariables.ossPreventiveMaintenanceInfo));

    const selectedCompany = sessionStorage.getItem(SessionVariables.selectedCompany) || null;
    const siteSelected = sessionStorage.getItem(SessionVariables.selectedSite) || null;
    const prioritySelected = sessionStorage.getItem(SessionVariables.selectedPriority) || null;

    const loggedIDetails = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const getAllContacts = JSON.parse(sessionStorage.getItem(SessionVariables.getContacts));
    const loggedData: any = loggedIDetails.data;
    const loggedUserInfo = loggedData.getLoggedInUserInfo;
    let contactDetails: any;
    for (const item of getAllContacts) {
      const name = `${item.firstName} ${item.lastName}`;
      const loggedName = `${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`;
      if (name === createCaseFirstFormData.contact) {
        contactDetails = item;
        break;
      } else if (createCaseFirstFormData.contact === loggedName) {
        const loggedObject = {
          phone: loggedUserInfo.workPhone,
          email: loggedUserInfo.email,
          customerContactNumber: loggedUserInfo.CFID
        };
        contactDetails = loggedObject;
        break;
      }
    }

    const siteGuid = createCaseFirstFormData.site ? `"{${createCaseFirstFormData.site}}"` : null;

    let brandProductCode: any;
    for (const item of JSON.parse(sessionStorage.getItem(SessionVariables.getProduct))) {
      if (item.prodTypeCode === ossProductRequestInfo.PRODUCT) {
        brandProductCode = item.brandProductCode;
      }
    }

    const firstName = loggedUserInfo.firstName || '';
    const middleName = loggedUserInfo.middleName || '';
    const lastName = loggedUserInfo.lastName || '';
    const submitterUserName = `${firstName} ${middleName} ${lastName}`;

    const contract = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.CONTRACT === 'Yes' ? 1 : 0;
    const processDown = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.PROCESS_DOWN === 'Yes' ? 1 : 0;
    const warranty = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.WARRANTY === 'Yes' ? 1 : 0;

    const allfieldServiceInfo = JSON.parse(sessionStorage.getItem(SessionVariables.getOssFieldServiceTypes));
    let selectedFieldService: any;
    for (const item of allfieldServiceInfo) {
      if (item.fieldServiceId === ossProductRequestInfoConfirm.FIELD_SERVICE) {
        selectedFieldService = item.description.trim();
      }
    }
    const poDate = ossProductRequestInfoConfirm.PO_DATE === null ? '-' : ossProductRequestInfoConfirm.PO_DATE;
    const warrantyEndDate = ossProductRequestInfoConfirm.WARRANTY_END_DATE === null ? '-' : ossProductRequestInfoConfirm.WARRANTY_END_DATE;

    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';

    // preventive maintanence
    const prcessOperating = ossPreventiveMaint.PROCESS_PLANT_OPERATING === 'Yes' ? 1 : 0;
    const softwareFailure = ossPreventiveMaint.SOFTWARE_FAILURE === 'Yes' ? 1 : 0;
    const hardwareFailure = ossPreventiveMaint.HARDWARE_FAILURE === 'Yes' ? 1 : 0;
    const partsRequired = ossPreventiveMaint.SERVICE_VISIT === 'Yes' ? 1 : 0;
    // tslint:disable-next-line: radix
    const duration = parseInt(ossPreventiveMaint && ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT);
    const ossPartsDetails = JSON.parse(sessionStorage.getItem(SessionVariables.ossPartsGridData));
    let partsStringArray = '';
    if (ossPartsDetails) {
      ossPartsDetails.map(attachment => {
        partsStringArray += `{ partNumber: "${attachment.PART_NUMBER}", quantity:1 serialNumber: "${attachment.SERIAL_NUMBER}",rev:"B", description:"screw", failureType:"F14", serviceTime:4 }`;
      });
    }
    if (ossPreventiveMaint) {
      if (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT) {
        let checkPrevSpeclSite = ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
        checkPrevSpeclSite = checkPrevSpeclSite.replaceAll('\'', "''");
        checkPrevSpeclSite = checkPrevSpeclSite.replaceAll('\"', "''");
        checkPrevSpeclSite = checkPrevSpeclSite.replaceAll('\n', '<br/>');
        ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT = checkPrevSpeclSite.trim();
      }
      if (ossPreventiveMaint.DESCRIPTION) {
        let checkPrevDesc = ossPreventiveMaint.DESCRIPTION;
        checkPrevDesc = checkPrevDesc.replaceAll('\'', "''");
        checkPrevDesc = checkPrevDesc.replaceAll('\"', "''");
        checkPrevDesc = checkPrevDesc.replaceAll('\n', '<br/>');
        ossPreventiveMaint.DESCRIPTION = checkPrevDesc.trim();
      }
      if (ossPreventiveMaint.ADDITIONAL_COMMENTS) {
        let checkAddntCmmnts = ossPreventiveMaint.ADDITIONAL_COMMENTS;
        checkAddntCmmnts = checkAddntCmmnts.replaceAll('\'', "''");
        checkAddntCmmnts = checkAddntCmmnts.replaceAll('\"', "''");
        checkAddntCmmnts = checkAddntCmmnts.replaceAll('\n', '<br/>');
        ossPreventiveMaint.ADDITIONAL_COMMENTS = checkAddntCmmnts.trim();
      }
    }
    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.CONFIGURATION && ossProductRequestInfoConfirm.CONFIGURATION !== '') {
      let checkConfig = ossProductRequestInfoConfirm.CONFIGURATION;
      checkConfig = checkConfig.replaceAll('\'', "''");
      checkConfig = checkConfig.replaceAll('\"', "''");
      checkConfig = checkConfig.replaceAll('\n', '<br/>');
      ossProductRequestInfoConfirm.CONFIGURATION = checkConfig.trim();
    }
    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.DESCRIPTION) {
      let checkDesc = ossProductRequestInfoConfirm.DESCRIPTION;
      checkDesc = checkDesc.replaceAll('\'', "''");
      checkDesc = checkDesc.replaceAll('\"', "''");
      checkDesc = checkDesc.replaceAll('\n', '<br/>');
      ossProductRequestInfoConfirm.DESCRIPTION = checkDesc.trim();
    }

    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.REPRODUCIBLE) {
      let checkReprod = ossProductRequestInfoConfirm.REPRODUCIBLE;
      checkReprod = checkReprod.replaceAll('\'', "''");
      ossProductRequestInfoConfirm.REPRODUCIBLE = checkReprod.trim();
    }

    // email template null check
    const emailSiteSelected = siteSelected === null ? '-' : siteSelected;
    const emailCustomerRef = (createCaseFirstFormData.customerref === null || createCaseFirstFormData.customerref === '')
      ? '-' : createCaseFirstFormData.customerref;
    const emailConfig = (ossProductRequestInfoConfirm.CONFIGURATION === null || ossProductRequestInfoConfirm.CONFIGURATION === '')
      ? '-' : ossProductRequestInfoConfirm.CONFIGURATION;
    const emailContract = ossProductRequestInfoConfirm.CONTRACT === null ? '-' : ossProductRequestInfoConfirm.CONTRACT;
    const emailPoNum = (ossProductRequestInfoConfirm.PO_NUMBER === null || ossProductRequestInfoConfirm.PO_NUMBER === '')
      ? '-' : ossProductRequestInfoConfirm.PO_NUMBER;
    const emailWarranty = ossProductRequestInfoConfirm.WARRANTY === null ? '-' : ossProductRequestInfoConfirm.WARRANTY;

    let emailDateOccured: any;
    let emailPoDate: any;
    let emailWarrantyEndDate: any;
    let emailServiceDateRequired: any;
    if (createCaseFirstFormData && createCaseFirstFormData.dateoccurred) {
      let splitDate: any;
      if (createCaseFirstFormData.dateoccurred.includes('T')) {
        splitDate = createCaseFirstFormData.dateoccurred.split('T');
        emailDateOccured = splitDate && splitDate[0];
      } else {
        emailDateOccured = createCaseFirstFormData.dateoccurred;
      }
    }

    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.PO_DATE) {
      let splitDate: any;
      if (ossProductRequestInfoConfirm.PO_DATE.includes('T')) {
        splitDate = ossProductRequestInfoConfirm.PO_DATE.split('T');
        emailPoDate = splitDate && splitDate[0];
      } else {
        emailPoDate = ossProductRequestInfoConfirm.PO_DATE || '-';
      }
    }
    else if (ossProductRequestInfoConfirm.PO_DATE === null || ossProductRequestInfoConfirm.PO_DATE === '' || ossProductRequestInfoConfirm.PO_DATE === undefined) {
      emailPoDate = '-';

    }

    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.WARRANTY_END_DATE) {
      let splitDate: any;
      if (ossProductRequestInfoConfirm.WARRANTY_END_DATE.includes('T')) {
        splitDate = ossProductRequestInfoConfirm.WARRANTY_END_DATE.split('T');
        emailWarrantyEndDate = splitDate && splitDate[0];
      } else {
        emailWarrantyEndDate = ossProductRequestInfoConfirm.WARRANTY_END_DATE || '-';
      }
    }
    else if (ossProductRequestInfoConfirm.WARRANTY_END_DATE === null || ossProductRequestInfoConfirm.WARRANTY_END_DATE === '' || ossProductRequestInfoConfirm.WARRANTY_END_DATE === undefined) {
      emailWarrantyEndDate = '-';

    }

    if (ossPreventiveMaint && ossPreventiveMaint.DATE_SERVICE_REQUIRED) {
      let splitDate: any;
      if (ossPreventiveMaint.DATE_SERVICE_REQUIRED.includes('T')) {
        splitDate = ossPreventiveMaint.DATE_SERVICE_REQUIRED.split('T');
        emailServiceDateRequired = splitDate && splitDate[0];
      } else {
        emailServiceDateRequired = ossPreventiveMaint.DATE_SERVICE_REQUIRED || '-';
      }
    }

    const getInput = this.makeOSSObjectsFieldService();
    this.apollo.mutate({
      mutation: gql`
      mutation{
        gcsCreateCaseSecure(input:${getInput}) {
          caseNumber
          message
        }
      }
 `,
    })
      .subscribe(
        data => {

          this.service.WritelogToCloudWatch("case submitted successfully",data)
          const getData: any = (data && data.data) || {};
          sessionStorage.setItem(SessionVariables.ossSubmitCaseData, JSON.stringify(getData && getData.gcsCreateCaseSecure));
          this.service.ossSubmitCase.next(true);
          let ossEmailTemp: any;
          let ccEmailBodyOss: string;
          if (selectedFieldService === 'Preventative Maintenance') {
            const emailAddCmmnts = (ossPreventiveMaint.ADDITIONAL_COMMENTS === null || ossPreventiveMaint.ADDITIONAL_COMMENTS === '')
              ? '-' : ossPreventiveMaint.ADDITIONAL_COMMENTS;
            const emailSpecltSite = (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === null
              || ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === '') ? '-' : ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Preventive Maintenance Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Plant Operating :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_OPERATING}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Duration :</b></span> <span class=''value''>${ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Preventive Maintenance Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Plant Operating :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_OPERATING}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Duration :</b></span> <span class=''value''>${ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;
          } else if (selectedFieldService === 'Equipment Breakdown') {
            const emailSpecltSite = (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === null
              || ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === '') ?
              '-' : ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
            let innerbody = '';
            const makePartsArray = [];
            if (ossPartsDetails) {
              ossPartsDetails.forEach((element, index) => {
                const obj = {
                  id: index + 1,
                  partNumber: element.PART_NUMBER,
                  serialNumber: element.SERIAL_NUMBER
                };
                makePartsArray.push(obj);
              });
            }
            makePartsArray.forEach((part) => {
              let allTrs = '';
              Object.entries(part).forEach((value, index) => {
                const td = `<td>${value && value[1]}</td>`;
                allTrs += `${td}`;
              });
              innerbody += `<tr>${allTrs}</tr>`;
            });
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Equipment Breakdown Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Software Failure :</b></span> <span class=''value''>${ossPreventiveMaint.SOFTWARE_FAILURE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Parts Required :</b></span> <span class=''value''>${ossPreventiveMaint.SERVICE_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Hardware Failure :</b></span> <span class=''value''>${ossPreventiveMaint.HARDWARE_FAILURE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${ossPreventiveMaint.DESCRIPTION}</span></div></div></div><div class=''parts-table''><h3>Parts Details</h3><table id=''parts''><thead><tr><th>ID</th><th>Part Number</th><th>Serial Number</th></tr></thead><tbody id=''t-body''>${innerbody}</tbody></table></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Equipment Breakdown Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Software Failure :</b></span> <span class=''value''>${ossPreventiveMaint.SOFTWARE_FAILURE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Parts Required :</b></span> <span class=''value''>${ossPreventiveMaint.SERVICE_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Hardware Failure :</b></span> <span class=''value''>${ossPreventiveMaint.HARDWARE_FAILURE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${ossPreventiveMaint.DESCRIPTION}</span></div></div></div><div class=''parts-table''><h3>Parts Details</h3><table id=''parts''><thead><tr><th>ID</th><th>Part Number</th><th>Serial Number</th></tr></thead><tbody id=''t-body''>${innerbody}</tbody></table></div></div></body></html>`;
          } else if (selectedFieldService === 'Field Engineering Services') {
            const emailSpecltSite = (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === null
              || ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === '') ?
              '-' : ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Field Engineering Services Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Service Required :</b></span> <span class=''value''>${ossPreventiveMaint.TYPE_OF_SERVICE_REQUIRED}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossPreventiveMaint.DESCRIPTION}</span></div></div></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Field Engineering Services Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Service Required :</b></span> <span class=''value''>${ossPreventiveMaint.TYPE_OF_SERVICE_REQUIRED}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossPreventiveMaint.DESCRIPTION}</span></div></div></div></div></body></html>`;
          } else if (selectedFieldService === 'Installation, Commissioning and Startup Services') {
            const emailSpecltSite = (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === null
              || ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === '') ?
              '-' : ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
            const emailAddCmmnts = (ossPreventiveMaint.ADDITIONAL_COMMENTS === null || ossPreventiveMaint.ADDITIONAL_COMMENTS === '') ?
              '-' : ossPreventiveMaint.ADDITIONAL_COMMENTS;
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Commissioning/Startup Services Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Support Required :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Commissioning/Startup Services Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Support Required :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;
          }
          else if (selectedFieldService === 'Training Request') {
            const emailCourseName = (ossPreventiveMaint.SERIAL_NUMBER === null || ossPreventiveMaint.SERIAL_NUMBER === '') ?
              '-' : ossPreventiveMaint.SERIAL_NUMBER;
            const emailCourseNum = (ossPreventiveMaint.PART_NUMBER === null || ossPreventiveMaint.PART_NUMBER === '') ?
              '-' : ossPreventiveMaint.PART_NUMBER;
            const emailAddCmmnts = (ossPreventiveMaint.ADDITIONAL_COMMENTS === null || ossPreventiveMaint.ADDITIONAL_COMMENTS === '') ?
              '-' : ossPreventiveMaint.ADDITIONAL_COMMENTS;
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Training Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Training Type :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Location :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE_2}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Course Number :</b></span> <span class=''value''>${emailCourseNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Standard/Custom :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE_1}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Number of Students :</b></span> <span class=''value''>${ossPreventiveMaint.STYLE_REVISION}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Course Name :</b></span> <span class=''value''>${emailCourseName}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>Training Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Training Type :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Location :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE_2}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Course Number :</b></span> <span class=''value''>${emailCourseNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Standard/Custom :</b></span> <span class=''value''>${ossPreventiveMaint.FIELD_SERVICE_1}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Number of Students :</b></span> <span class=''value''>${ossPreventiveMaint.STYLE_REVISION}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Course Name :</b></span> <span class=''value''>${emailCourseName}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;
          }
          else if (selectedFieldService === 'System Upgrade Services') {
            const emailCustPoNum = (ossPreventiveMaint.CUSTOMER_ORDER_EQUIPMENT === null || ossPreventiveMaint.CUSTOMER_ORDER_EQUIPMENT === '') ?
              '-' : ossPreventiveMaint.CUSTOMER_ORDER_EQUIPMENT;
            const emailInvensysOrderNum = (ossPreventiveMaint.INVENSYS_ORDER_EQUIPMENT === null
              || ossPreventiveMaint.INVENSYS_ORDER_EQUIPMENT === '') ?
              '-' : ossPreventiveMaint.INVENSYS_ORDER_EQUIPMENT;
            const emailAddCmmnts = (ossPreventiveMaint.ADDITIONAL_COMMENTS === null || ossPreventiveMaint.ADDITIONAL_COMMENTS === '') ?
              '-' : ossPreventiveMaint.ADDITIONAL_COMMENTS;
            const emailSpecltSite = (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === null
              || ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT === '') ?
              '-' : ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
            ossEmailTemp = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div class=''dear''>Dear ${createCaseFirstFormData.contact},</div><div> Thank you for contacting Schneider Electric. Your case reference number is: <b>${getData.gcsCreateCaseSecure.caseNumber}.</b><br /> Your question has been received. You should expect a response from us within three(3) business days.</div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>System Upgrade Service Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Visit Duration :</b></span> <span class=''value''>${ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Customer PO No :</b></span> <span class=''value''>${emailCustPoNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Hardware Upgrade :</b></span> <span class=''value''>${ossPreventiveMaint.HARDWARE_UPGRADE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Planned Shutdown :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_PLANNED}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Plant Operating :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_OPERATING}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Invensys Order No :</b></span> <span class=''value''>${emailInvensysOrderNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Software Upgrade :</b></span> <span class=''value''>${ossPreventiveMaint.SOFTWARE_UPGRADE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;

            ccEmailBodyOss = `<html> <header><style>body{font-family:ArialRoundedMTforSE_Latin,Arial,''Helvetica Neue'',Helvetica,sans-serif}.row{margin:12px 0px}.row div{width:100%;margin:10px 0px}h3{color:#3dcd58;margin-bottom:5px;font-size:17px;margin-top:25px;display:inline-block}div.dear{margin-bottom:15px}span{font-size:14px}.field{width:200px;display:inline-block}.status{padding:32px}.case-number{width:74%;margin:0 auto}.status span{width:20px;height:20px;background:#3dcd58;float:left;margin-left:20px;margin-right:15px;border-radius:100%}table{border-collapse:collapse;width:100%}th{border:none !important;background:#eaeaea}td,th{border:none;text-align:left;padding:8px;font-size:14px}#mep-email-template{width:70%;padding:20px 40px;margin:0 auto}.value{width:75%;display:inline-block}.note{color:red;margin-top:15px}</style></header><body><div id=''mep-email-template''><div class=''case-body''><div><b>Case Queue Email***</b></div><h3>Case Information</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Case Type :</b></span> <span class=''value''>${createCaseFirstFormData.caseType}</span></div><div> <span class=''field''><b>Company :</b></span> <span class=''value''>${selectedCompany}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Priority :</b></span> <span class=''value''>${prioritySelected}</span></div><div> <span class=''field''><b>Site :</b></span> <span class=''value''>${emailSiteSelected}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Occurred :</b></span> <span class=''value''>${emailDateOccured}</span></div><div> <span class=''field''><b>Contact :</b></span> <span class=''value''>${createCaseFirstFormData.contact}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Field Service Type :</b></span> <span class=''value''>${selectedFieldService}</span></div><div> <span class=''field''><b>Customer Reference:</b></span> <span class=''value''>${emailCustomerRef}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Submitted By :</b></span> <span class=''value''>${submitterUserName}</span></div></div></div><div class=''product-info''><h3>Product Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Product Family :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_FAMILY}</span></div><div> <span class=''field''><b>Product Group :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_GROUP}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Product :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT}</span></div><div> <span class=''field''><b>Product Version:</b></span> <span class=''value''>${ossProductRequestInfoConfirm.PRODUCT_VERSION}</span></div></div></div><div class=''request-info''><h3>Request Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Area :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.AREA}</span></div><div> <span class=''field''><b>Reproducible :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.REPRODUCIBLE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Configuration :</b></span> <span class=''value''>${emailConfig}</span></div><div> <span class=''field''><b>Description :</b></span> <span class=''value''>${ossProductRequestInfoConfirm.DESCRIPTION}</span></div></div></div><div class=''commercial-info''><h3>Commercial Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Number :</b></span> <span class=''value''>${emailPoNum}</span></div><div> <span class=''field''><b>Warranty :</b></span> <span class=''value''>${emailWarranty}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>PO Date :</b></span> <span class=''value''>${emailPoDate}</span></div><div> <span class=''field''><b>Warranty End Date :</b></span> <span class=''value''>${emailWarrantyEndDate}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Contract :</b></span> <span class=''value''>${emailContract}</span></div></div></div><div class=''shpping-info''><h3>System Upgrade Service Info</h3><div class=''row''><div class=''first-child''> <span class=''field''><b>Date Required :</b></span> <span class=''value''>${emailServiceDateRequired}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Visit Duration :</b></span> <span class=''value''>${ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Customer PO No :</b></span> <span class=''value''>${emailCustPoNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Hardware Upgrade :</b></span> <span class=''value''>${ossPreventiveMaint.HARDWARE_UPGRADE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Planned Shutdown :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_PLANNED}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Plant Operating :</b></span> <span class=''value''>${ossPreventiveMaint.PROCESS_PLANT_OPERATING}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Invensys Order No :</b></span> <span class=''value''>${emailInvensysOrderNum}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Software Upgrade :</b></span> <span class=''value''>${ossPreventiveMaint.SOFTWARE_UPGRADE}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Site Requirements :</b></span> <span class=''value''>${emailSpecltSite}</span></div></div><div class=''row''><div class=''first-child''> <span class=''field''><b>Additional Comments :</b></span> <span class=''value''>${emailAddCmmnts}</span></div></div></div></div></body></html>`;
          }
          const ossSubmitCase = JSON.parse(sessionStorage.getItem(SessionVariables.ossSubmitCaseData)) || null;
          if (ossSubmitCase && ossSubmitCase !== undefined && ossSubmitCase !== null) {
            this.emailNotification(ossEmailTemp, contactDetails.email, createCaseFirstFormData.company,
              ossSubmitCase.caseNumber, ccEmailBodyOss, ossProductRequestInfoConfirm.DESCRIPTION, 'OSS');
          }
        },
        (err) => {
          this.service.WritelogToCloudWatch(err)
          const errorMessage = err.message;
          if (errorMessage.includes(ErrorCodes.JWT_EXPIRED)) {
            // code to refresh token and to call again
            this.gcsGraphQlSessionIdServiceSecure.getSessionId().subscribe(
              (result) => {
                const data = result.data.renewToken;
                if (data.message.includes(ErrorCodes.REFRESH_TOKEN_EXPIRED)) {
                  // probably should logout the user
                } else if (data.JWT) {
                  sessionStorage.setItem(SessionVariables.sessionToken, data.JWT);
                  const updateSessionData = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
                  updateSessionData.data.getLoggedInUserInfo.JWT = data.JWT;
                  updateSessionData.data.getLoggedInUserInfo.JWTRefreshToken = data.refreshToken;
                  updateSessionData.data.getLoggedInUserInfo.accessToken = data.accessToken;
                  updateSessionData.data.getLoggedInUserInfo.apigeeAccessToken = data.apigeeAccessToken;
                  sessionStorage.setItem(SessionVariables.loggedInUserDetails, JSON.stringify(updateSessionData));
                  this.ossSubmitCaseMutation();
                }
              });
          }
          else {
            const userCode = this.service.getIds();


            this.service.errorLogHandling.next({
              userCode: userCode.user_code,
              LogText: "ossSubmitCaseMutation",
              SourceApp: "GCSWeb2020",
              API_HTTP_Code: "5000",
              API_Error_Code: "5000",
              API_URL: "",
              API_Error_Type: err.name,
              API_UserMessage: "Unable to Submit Form: Please contact local support for assistance.",
              API_DevMessage: err.stack,
              API_Data: ''
            });


          }
        }
      );
  }

  public makeOSSObjectsFieldService(): any {
    const createCaseFirstFormData = JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm));
    // OSS forms data
    const ossProductRequestInfo = JSON.parse(sessionStorage.getItem(SessionVariables.ossProductRequestInfo));
    const ossProductRequestInfoConfirm = JSON.parse(sessionStorage.getItem(SessionVariables.ossProductDataConfirm));
    const ossPreventiveMaint = JSON.parse(sessionStorage.getItem(SessionVariables.ossPreventiveMaintenanceInfo));

    const selectedCompany = sessionStorage.getItem(SessionVariables.selectedCompany) || null;
    const siteSelected = sessionStorage.getItem(SessionVariables.selectedSite) || null;
    const prioritySelected = sessionStorage.getItem(SessionVariables.selectedPriority) || null;

    const loggedIDetails = JSON.parse(sessionStorage.getItem(SessionVariables.loggedInUserDetails));
    const getAllContacts = JSON.parse(sessionStorage.getItem(SessionVariables.getContacts));
    const loggedData: any = loggedIDetails.data;
    const loggedUserInfo = loggedData.getLoggedInUserInfo;
    let contactDetails: any;
    // for (const item of getAllContacts) {
    //   const name = `${item.firstName} ${item.lastName}`;
    //   const loggedName = `${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`;
    //   if (name === createCaseFirstFormData.contact) {
    //     contactDetails = item;
    //     break;
    //   } else if (createCaseFirstFormData.contact === loggedName) {
    //     const loggedObject = {
    //       phone: loggedUserInfo.workPhone,
    //       email: loggedUserInfo.email,
    //       customerContactNumber: loggedUserInfo.CFID
    //     };
    //     contactDetails = loggedObject;
    //     break;
    //   }
    // }
    let isContactFind = false;
    for (const item of getAllContacts) {
      const name = `${item.firstName} ${item.lastName}`;
      const itemCFID = parseInt(item.customerContactNumber, 10);
      if (name === createCaseFirstFormData.contact) {
        contactDetails = item;
        isContactFind = true;
        break;
      } else if (loggedUserInfo.CFIDList && loggedUserInfo.CFIDList.includes(itemCFID)) {
        contactDetails = item;
        isContactFind = true;
        break;
      }
    }
    if (!isContactFind) {
      const loggedName = `${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`;
      if (createCaseFirstFormData.contact === loggedName) {
        const loggedObject = {
          phone: loggedUserInfo.workPhone,
          email: loggedUserInfo.email,
          customerContactNumber: loggedUserInfo.CFID
        };
        contactDetails = loggedObject;
      }
    }
    const siteGuid = createCaseFirstFormData.site ? `"{${createCaseFirstFormData.site}}"` : null;

    let brandProductCode: any;
    for (const item of JSON.parse(sessionStorage.getItem(SessionVariables.getProduct))) {
      if (item.prodTypeCode === ossProductRequestInfo.PRODUCT) {
        brandProductCode = item.brandProductCode;
      }
    }

    const firstName = loggedUserInfo.firstName || '';
    const middleName = loggedUserInfo.middleName || '';
    const lastName = loggedUserInfo.lastName || '';
    const submitterUserName = `${firstName} ${middleName} ${lastName}`;
    const submitterPhone = loggedUserInfo.workPhone || '';
    const phone = contactDetails.phone || '';

    const contract = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.CONTRACT === 'Yes' ? 1 : 0;
    const processDown = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.PROCESS_DOWN === 'Yes' ? 1 : 0;
    const warranty = ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.WARRANTY === 'Yes' ? 1 : 0;

    const allfieldServiceInfo = JSON.parse(sessionStorage.getItem(SessionVariables.getOssFieldServiceTypes));
    let selectedFieldService: any;
    for (const item of allfieldServiceInfo) {
      if (item.fieldServiceId === ossProductRequestInfoConfirm.FIELD_SERVICE) {
        selectedFieldService = item.description.trim();
      }
    }
    const poDate = ossProductRequestInfoConfirm.PO_DATE === null ? "" : ossProductRequestInfoConfirm.PO_DATE;
    const warrantyEndDate = ossProductRequestInfoConfirm.WARRANTY_END_DATE === null ? "" : ossProductRequestInfoConfirm.WARRANTY_END_DATE;

    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = '';

    // preventive maintanence
    const prcessOperating = ossPreventiveMaint.PROCESS_PLANT_OPERATING === 'Yes' ? 1 : 0;
    const softwareFailure = ossPreventiveMaint.SOFTWARE_FAILURE === 'Yes' ? 1 : 0;
    const hardwareFailure = ossPreventiveMaint.HARDWARE_FAILURE === 'Yes' ? 1 : 0;
    const partsRequired = ossPreventiveMaint.SERVICE_VISIT === 'Yes' ? 1 : 0;
    // tslint:disable-next-line: radix
    const duration = parseInt(ossPreventiveMaint && ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT);
    const ossPartsDetails = JSON.parse(sessionStorage.getItem(SessionVariables.ossPartsGridData));
    let partsStringArray = '';
    if (ossPartsDetails) {
      ossPartsDetails.map(attachment => {
        partsStringArray += `{ partNumber: "${attachment.PART_NUMBER}", quantity:1 serialNumber: "${attachment.SERIAL_NUMBER}",rev:"B", description:"screw", failureType:"F14", serviceTime:4 }`;
      });
    }
    if (ossPreventiveMaint) {
      if (ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT) {
        let checkPrevSpeclSite = ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT;
        checkPrevSpeclSite = checkPrevSpeclSite.replaceAll('\'', "''");
        checkPrevSpeclSite = checkPrevSpeclSite.replaceAll('\"', "''");
        ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT = `""${checkPrevSpeclSite.trim()}""`;
      }
      if (ossPreventiveMaint.DESCRIPTION) {
        let checkPrevDesc = ossPreventiveMaint.DESCRIPTION;
        checkPrevDesc = checkPrevDesc.replaceAll('\'', "''");
        checkPrevDesc = checkPrevDesc.replaceAll('\"', "''");
        ossPreventiveMaint.DESCRIPTION = `""${checkPrevDesc.trim()}""`;
      }
      if (ossPreventiveMaint.ADDITIONAL_COMMENTS) {
        let checkAddntCmmnts = ossPreventiveMaint.ADDITIONAL_COMMENTS;
        checkAddntCmmnts = checkAddntCmmnts.replaceAll('\'', "''");
        checkAddntCmmnts = checkAddntCmmnts.replaceAll('\"', "''");
        ossPreventiveMaint.ADDITIONAL_COMMENTS = `""${checkAddntCmmnts.trim()}""`;
      }
    }
    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.CONFIGURATION && ossProductRequestInfoConfirm.CONFIGURATION !== '') {
      let checkConfig = ossProductRequestInfoConfirm.CONFIGURATION;
      checkConfig = checkConfig.replaceAll('\'', "''");
      checkConfig = checkConfig.replaceAll('\"', "''");
      ossProductRequestInfoConfirm.CONFIGURATION = `""${checkConfig.trim()}""`;
    }
    if (ossProductRequestInfoConfirm && ossProductRequestInfoConfirm.DESCRIPTION) {
      let checkDesc = ossProductRequestInfoConfirm.DESCRIPTION;
      checkDesc = checkDesc.replaceAll('\'', "''");
      checkDesc = checkDesc.replaceAll('\"', "''");
      ossProductRequestInfoConfirm.DESCRIPTION = checkDesc.trim();
    }
    if (selectedFieldService === 'Preventative Maintenance') {
      const makeObj = `{
          JWT: "${sessionToken}",
          screenId: "${screenId}",
          ipAddress: "${ip}",
          caseTypeCode:"${createCaseFirstFormData.caseType}",
          carNumber:null,
          localCompanyCode:${createCaseFirstFormData.company},
          siteGuid:${siteGuid},
          contactFullName:"${createCaseFirstFormData.contact}",
          contactId:"${contactDetails.customerContactNumber}",
          phone:"${phone}",
          email:"${contactDetails.email}",
          SEContactName:"",
          SEConactPhone:"",
          SEContactEmail:"",
          submitterFullName:"${submitterUserName}",
          submitterPhone:"${submitterPhone}",
          submitterEmail:"${loggedUserInfo.email}",
          dateOccured:"${createCaseFirstFormData.dateoccurred}",
          locationCode:"${ossProductRequestInfo.AREA}",
          reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
          impactCode:"${createCaseFirstFormData.priority}",
          issueType:"",
          brandProductCode:${brandProductCode},
          hardwareCode:"9",
          versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
          customerRefField:"${createCaseFirstFormData.customerref}",
          configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
          descriptionInput:"""${ossProductRequestInfoConfirm.DESCRIPTION}""",
          suggestedSolution:"Test Suggested Solution",
          benefitText:"Test Benefit Input",
          CRUserId:"",
          RMACode:"",
          carTypeCode:1,
          caseType:"${createCaseFirstFormData.caseType}",
          salesOrderNumber:"12345",
          serviceOrderNumber:"",
          SAFEffect:"I",
          PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
          POEndDate:"${poDate}",
          webCode:null,
          newCaseGUID:null,
          qualCode:"",
          goldenID:"",
          fieldServiceType:"${selectedFieldService}",
          contract:${contract},
          warranty: ${warranty},
          warrantyExpires:"${warrantyEndDate}",
          dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
          duration:${duration},
          processOperating: ${prcessOperating},
          specialRequirements:"${ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT}",
          additionalComments:"${ossPreventiveMaint.ADDITIONAL_COMMENTS}",
          ossPriority:"ossTestPriority",
          hardwareFailure:0,
          partsRequired:0,
          softwareFailure:0,
          problemDescription:"TestProblemDescriptionTest",
          serviceRequired:"TestProblemDescription",
          standardCourse:0,
          trainingLocation:"TestTrainingLocation",
          courseNumber:"TestCourseNumber",
          courseName:"TestCourseName",
          numberOfStudents:5,
          customerPONum:"TestCustomerPONum",
          plannedShutdown:0,
          hardwareUpgrade:0,
          softwareUpdgrade:0,
          trainingType:"TestTrainingType",
          partsDetails:[
            {
              partNumber:"j0173be",
              quantity:1,
              serialNumber:"SC283112",
              rev:"B",
              description:"screw",
              failureType:"F14",
              serviceTime:4
              },
              {
              partNumber:"j0173be",
              quantity:1,
              serialNumber:"SC283112",
              rev:"B",
              description:"screw",
              failureType:"F14",
              serviceTime:4
              }
          ]
      }`;
      return makeObj;
    }
    else if (selectedFieldService === 'Equipment Breakdown') {
      const makeObj = `{
        JWT: "${sessionToken}",
        screenId: "${screenId}",
        ipAddress: "${ip}",
        caseTypeCode:"${createCaseFirstFormData.caseType}",
        carNumber:null,
        localCompanyCode:${createCaseFirstFormData.company},
        siteGuid:${siteGuid},
        contactFullName:"${createCaseFirstFormData.contact}",
        contactId:"${contactDetails.customerContactNumber}",
        phone:"${phone}",
        email:"${contactDetails.email}",
        SEContactName:"",
        SEConactPhone:"",
        SEContactEmail:"",
        submitterFullName:"${submitterUserName}",
        submitterPhone:"${submitterPhone}",
        submitterEmail:"${loggedUserInfo.email}",
        dateOccured:"${createCaseFirstFormData.dateoccurred}",
        locationCode:"${ossProductRequestInfo.AREA}",
        reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
        impactCode:"${createCaseFirstFormData.priority}",
        issueType:"",
        brandProductCode:${brandProductCode},
        hardwareCode:"9",
        versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
        customerRefField:"${createCaseFirstFormData.customerref}",
        configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
        descriptionInput:"${ossProductRequestInfoConfirm.DESCRIPTION}",
        suggestedSolution:"Test Suggested Solution",
        benefitText:"Test Benefit Input",
        CRUserId:"",
        RMACode:"",
        carTypeCode:1,
        caseType:"${createCaseFirstFormData.caseType}",
        salesOrderNumber:"12345",
        serviceOrderNumber:"",
        SAFEffect:"I",
        PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
        POEndDate:"${poDate}",
        webCode:null,
        newCaseGUID:null,
        qualCode:"",
        goldenID:"",
        fieldServiceType:"${selectedFieldService}",
        contract:${contract},
        warranty: ${warranty},
        warrantyExpires:"${warrantyEndDate}",
        dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
        duration:11,
        processOperating: ${prcessOperating},
        specialRequirements:"${ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT}",
        additionalComments:"${ossPreventiveMaint.DESCRIPTION}",
        ossPriority:"ossTestPriority",
        hardwareFailure: ${hardwareFailure},
        partsRequired: ${partsRequired},
        softwareFailure: ${softwareFailure},
        problemDescription:"TestProblemDescriptionTest",
        serviceRequired:"TestProblemDescription",
        standardCourse:0,
        trainingLocation:"TestTrainingLocation",
        courseNumber:"TestCourseNumber",
        courseName:"TestCourseName",
        numberOfStudents:5,
        customerPONum:"TestCustomerPONum",
        plannedShutdown:0,
        hardwareUpgrade:0,
        softwareUpdgrade:0,
        trainingType:"TestTrainingType",
        partsDetails:[${partsStringArray}]
      }`;
      return makeObj;
    }
    else if (selectedFieldService === 'Field Engineering Services') {
      const makeObj = `{
        JWT: "${sessionToken}",
        screenId: "${screenId}",
        ipAddress: "${ip}",
        caseTypeCode:"${createCaseFirstFormData.caseType}",
        carNumber:null,
        localCompanyCode:${createCaseFirstFormData.company},
        siteGuid:${siteGuid},
        contactFullName:"${createCaseFirstFormData.contact}",
        contactId:"${contactDetails.customerContactNumber}",
        phone:"${phone}",
        email:"${contactDetails.email}",
        SEContactName:"",
        SEConactPhone:"",
        SEContactEmail:"",
        submitterFullName:"${submitterUserName}",
        submitterPhone:"${submitterPhone}",
        submitterEmail:"${loggedUserInfo.email}",
        dateOccured:"${createCaseFirstFormData.dateoccurred}",
        locationCode:"${ossProductRequestInfo.AREA}",
        reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
        impactCode:"${createCaseFirstFormData.priority}",
        issueType:"",
        brandProductCode:${brandProductCode},
        hardwareCode:"9",
        versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
        customerRefField:"${createCaseFirstFormData.customerref}",
        configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
        descriptionInput:"""${ossProductRequestInfoConfirm.DESCRIPTION}""",
        suggestedSolution:"Test Suggested Solution",
        benefitText:"Test Benefit Input",
        CRUserId:"",
        RMACode:"",
        carTypeCode:1,
        caseType:"${createCaseFirstFormData.caseType}",
        salesOrderNumber:"12345",
        serviceOrderNumber:"",
        SAFEffect:"I",
        PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
        POEndDate:"${poDate}",
        webCode:null,
        newCaseGUID:null,
        qualCode:"",
        goldenID:"",
        fieldServiceType:"${selectedFieldService}",
        contract:${contract},
        warranty: ${warranty},
        warrantyExpires:"${warrantyEndDate}",
        dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
        duration:11,
        processOperating: ${prcessOperating},
        specialRequirements:"${ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT}",
        additionalComments:"${ossPreventiveMaint.DESCRIPTION}",
        ossPriority:"ossTestPriority",
        hardwareFailure:0,
        partsRequired:0,
        softwareFailure:0,
        problemDescription:"${ossPreventiveMaint.DESCRIPTION}",
        serviceRequired:"${ossPreventiveMaint.TYPE_OF_SERVICE_REQUIRED}",
        standardCourse:0,
        trainingLocation:"TestTrainingLocation",
        courseNumber:"TestCourseNumber",
        courseName:"TestCourseName",
        numberOfStudents:5,
        customerPONum:"TestCustomerPONum",
        plannedShutdown:0,
        hardwareUpgrade:0,
        softwareUpdgrade:0,
        trainingType:"TestTrainingType",
        partsDetails:[
        {
          partNumber:"j0173be",
          quantity:1,
          serialNumber:"SC283112",
          rev:"B",
          description:"screw",
          failureType:"F14",
          serviceTime:4
          },
          {
          partNumber:"j0173be",
          quantity:1,
          serialNumber:"SC283112",
          rev:"B",
          description:"screw",
          failureType:"F14",
          serviceTime:4
          }
        ]
      }`;
      return makeObj;
    } else if (selectedFieldService === 'Installation, Commissioning and Startup Services') {
      const makeObj = `{
        JWT: "${sessionToken}",
        screenId: "${screenId}",
        ipAddress: "${ip}",
        caseTypeCode:"${createCaseFirstFormData.caseType}",
        carNumber:null,
        localCompanyCode:${createCaseFirstFormData.company},
        siteGuid:${siteGuid},
        contactFullName:"${createCaseFirstFormData.contact}",
        contactId:"${contactDetails.customerContactNumber}",
        phone:"${phone}",
        email:"${contactDetails.email}",
        SEContactName:"",
        SEConactPhone:"",
        SEContactEmail:"",
        submitterFullName:"${submitterUserName}",
        submitterPhone:"${submitterPhone}",
        submitterEmail:"${loggedUserInfo.email}",
        dateOccured:"${createCaseFirstFormData.dateoccurred}",
        locationCode:"${ossProductRequestInfo.AREA}",
        reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
        impactCode:"${createCaseFirstFormData.priority}",
        issueType:"",
        brandProductCode:${brandProductCode},
        hardwareCode:"9",
        versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
        customerRefField:"${createCaseFirstFormData.customerref}",
        configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
        descriptionInput:"""${ossProductRequestInfoConfirm.DESCRIPTION}""",
        suggestedSolution:"Test Suggested Solution",
        benefitText:"Test Benefit Input",
        CRUserId:"",
        RMACode:"",
        carTypeCode:1,
        caseType:"${createCaseFirstFormData.caseType}",
        salesOrderNumber:"12345",
        serviceOrderNumber:"",
        SAFEffect:"I",
        PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
        POEndDate:"${poDate}",
        webCode:null,
        newCaseGUID:null,
        qualCode:"",
        goldenID:"",
        fieldServiceType:"${selectedFieldService}",
        contract:${contract},
        warranty: ${warranty},
        warrantyExpires:"${warrantyEndDate}",
        dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
        duration:11,
        processOperating:1,
        specialRequirements:"${ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT}",
        additionalComments:"${ossPreventiveMaint.ADDITIONAL_COMMENTS}",
        ossPriority:"ossTestPriority",
        hardwareFailure:0,
        partsRequired:0,
        softwareFailure:0,
        problemDescription:"TestProblemDescriptionTest",
        serviceRequired:"${ossPreventiveMaint.FIELD_SERVICE}",
        standardCourse:0,
        trainingLocation:"TestTrainingLocation",
        courseNumber:"TestCourseNumber",
        courseName:"TestCourseName",
        numberOfStudents:5,
        customerPONum:"TestCustomerPONum",
        plannedShutdown:0,
        hardwareUpgrade:0,
        softwareUpdgrade:0,
        trainingType:"TestTrainingType",
        partsDetails:[
          {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            },
            {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            }
        ]
      }`;
      return makeObj;
    }
    else if (selectedFieldService === 'Training Request') {
      const standardCourse = ossPreventiveMaint.FIELD_SERVICE_1 === 'On-Site' ? 1 : 0;
      const students = parseInt(ossPreventiveMaint && ossPreventiveMaint.STYLE_REVISION, 10);
      const makeObj = `{
        JWT: "${sessionToken}",
        screenId: "${screenId}",
        ipAddress: "${ip}",
        caseTypeCode:"${createCaseFirstFormData.caseType}",
        carNumber:null,
        localCompanyCode:${createCaseFirstFormData.company},
        siteGuid:${siteGuid},
        contactFullName:"${createCaseFirstFormData.contact}",
        contactId:"${contactDetails.customerContactNumber}",
        phone:"${phone}",
        email:"${contactDetails.email}",
        SEContactName:"",
        SEConactPhone:"",
        SEContactEmail:"",
        submitterFullName:"${submitterUserName}",
        submitterPhone:"${submitterPhone}",
        submitterEmail:"${loggedUserInfo.email}",
        dateOccured:"${createCaseFirstFormData.dateoccurred}",
        locationCode:"${ossProductRequestInfo.AREA}",
        reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
        impactCode:"${createCaseFirstFormData.priority}",
        issueType:"",
        brandProductCode:${brandProductCode},
        hardwareCode:"9",
        versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
        customerRefField:"${createCaseFirstFormData.customerref}",
        configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
        descriptionInput:"""${ossProductRequestInfoConfirm.DESCRIPTION}""",
        suggestedSolution:"Test Suggested Solution",
        benefitText:"Test Benefit Input",
        CRUserId:"",
        RMACode:"",
        carTypeCode:1,
        caseType:"${createCaseFirstFormData.caseType}",
        salesOrderNumber:"12345",
        serviceOrderNumber:"",
        SAFEffect:"I",
        PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
        POEndDate:"${poDate}",
        webCode:null,
        newCaseGUID:null,
        qualCode:"",
        goldenID:"",
        fieldServiceType:"${selectedFieldService}",
        contract:${contract},
        warranty: ${warranty},
        warrantyExpires:"${warrantyEndDate}",
        dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
        duration:11,
        processOperating: 1,
        specialRequirements:"no special req",
        additionalComments:"${ossPreventiveMaint.ADDITIONAL_COMMENTS}",
        ossPriority:"ossTestPriority",
        hardwareFailure:0,
        partsRequired:0,
        softwareFailure:0,
        problemDescription:"TestProblemDescription",
        serviceRequired:"TestProblemDescription",
        standardCourse: ${standardCourse},
        trainingLocation:"${ossPreventiveMaint.FIELD_SERVICE_2}",
        courseNumber:"${ossPreventiveMaint.PART_NUMBER}",
        courseName:"${ossPreventiveMaint.SERIAL_NUMBER}",
        numberOfStudents: ${students},
        customerPONum:"TestCustomerPONum",
        plannedShutdown:0,
        hardwareUpgrade:0,
        softwareUpdgrade:0,
        trainingType:"${ossPreventiveMaint.FIELD_SERVICE}",
        partsDetails:[
          {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            },
            {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            }
        ]
      }`;
      return makeObj;
    } else if (selectedFieldService === 'System Upgrade Services') {
      const hardwareUpgrade = ossPreventiveMaint.HARDWARE_UPGRADE === 'Yes' ? 1 : 0;
      const softwareUpgrade = ossPreventiveMaint.SOFTWARE_UPGRADE === 'Yes' ? 1 : 0;
      const plannedShutdown = ossPreventiveMaint.PROCESS_PLANT_PLANNED === 'Yes' ? 1 : 0;
      const plannedOperating = ossPreventiveMaint.PROCESS_PLANT_OPERATING === 'Yes' ? 1 : 0;
      // const plannedShutdown = ossPreventiveMaint.PROCESS_PLANT_PLANNED === 'Yes' ? 1 : 0;
      const visitduration = parseInt(ossPreventiveMaint && ossPreventiveMaint.ESTIMATED_DURATION_OF_VISIT, 10);
      const makeObj = `{
        JWT: "${sessionToken}",
        screenId: "${screenId}",
        ipAddress: "${ip}",
        caseTypeCode:"${createCaseFirstFormData.caseType}",
        carNumber:null,
        localCompanyCode:${createCaseFirstFormData.company},
        siteGuid:${siteGuid},
        contactFullName:"${createCaseFirstFormData.contact}",
        contactId:"${contactDetails.customerContactNumber}",
        phone:"${phone}",
        email:"${contactDetails.email}",
        SEContactName:"",
        SEConactPhone:"",
        SEContactEmail:"",
        submitterFullName:"${submitterUserName}",
        submitterPhone:"${submitterPhone}",
        submitterEmail:"${loggedUserInfo.email}",
        dateOccured:"${createCaseFirstFormData.dateoccurred}",
        locationCode:"${ossProductRequestInfo.AREA}",
        reproducibleCode:"${ossProductRequestInfo.REPRODUCIBLE}",
        impactCode:"${createCaseFirstFormData.priority}",
        issueType:"",
        brandProductCode:${brandProductCode},
        hardwareCode:"9",
        versionCode:"${ossProductRequestInfo.PRODUCT_VERSION}",
        customerRefField:"${createCaseFirstFormData.customerref}",
        configurationInput:"${ossProductRequestInfoConfirm.CONFIGURATION}",
        descriptionInput:"""${ossProductRequestInfoConfirm.DESCRIPTION}""",
        suggestedSolution:"Test Suggested Solution",
        benefitText:"Test Benefit Input",
        CRUserId:"",
        RMACode:"",
        carTypeCode:1,
        caseType:"${createCaseFirstFormData.caseType}",
        salesOrderNumber:"${ossPreventiveMaint.INVENSYS_ORDER_EQUIPMENT}",
        serviceOrderNumber:"",
        SAFEffect:"I",
        PONumber:"${ossProductRequestInfoConfirm.PO_NUMBER}",
        POEndDate:"${poDate}",
        webCode:null,
        newCaseGUID:null,
        qualCode:"",
        goldenID:"",
        fieldServiceType:"${selectedFieldService}",
        contract:${contract},
        warranty: ${warranty},
        warrantyExpires:"${warrantyEndDate}",
        dateRequired:"${ossPreventiveMaint.DATE_SERVICE_REQUIRED}",
        duration:${visitduration},
        processOperating: ${plannedOperating},
        specialRequirements:"${ossPreventiveMaint.SPECIAL_SITE_REQUIREMENTS_VISIT}",
        additionalComments:"${ossPreventiveMaint.ADDITIONAL_COMMENTS}",
        ossPriority:"ossTestPriority",
        hardwareFailure:0,
        partsRequired:0,
        softwareFailure:0,
        problemDescription:"TestProblemDescriptionTest",
        serviceRequired:"TestProblemDescription",
        standardCourse:0,
        trainingLocation:"TestTrainingLocation",
        courseNumber:"TestCourseNumber",
        courseName:"TestCourseName",
        numberOfStudents:5,
        customerPONum:"${ossPreventiveMaint.CUSTOMER_ORDER_EQUIPMENT}",
        plannedShutdown:${plannedShutdown},
        hardwareUpgrade: ${hardwareUpgrade},
        softwareUpdgrade: ${softwareUpgrade},
        trainingType:"TestTrainingType",
        partsDetails:[
          {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            },
            {
            partNumber:"j0173be",
            quantity:1,
            serialNumber:"SC283112",
            rev:"B",
            description:"screw",
            failureType:"F14",
            serviceTime:4
            }
        ]
      }`;
      return makeObj;
    }
  }


  public getOssSummary(userCode: number, caseNumber: any, caseType: any): void {
    let userOssQuery: QueryRef<any>;
    const getuserCode = userCode || sessionStorage.getItem(SessionVariables.homeUseCode);
    if (!caseNumber && !caseType) {
      const homeCaseNumber = sessionStorage.getItem(SessionVariables.homeCaseNumber) || null;
      const homeCaseType = sessionStorage.getItem(SessionVariables.homeCaseType) || null;
      caseType = (homeCaseType && homeCaseType.trim()) || JSON.parse(sessionStorage.getItem(SessionVariables.createCaseFirstForm)).caseType;
      caseNumber = parseInt(homeCaseNumber) || JSON.parse(sessionStorage.getItem(SessionVariables.ossSubmitCaseData)).caseNumber;
    }
    let ip = sessionStorage.getItem(SessionVariables.ip);
    ip = ip ? ip : '';
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);
    let screenId = screenIdsForTelemetry['home-overview'].screenId;
    // get the fed Id and stick in inside line 22 deferated
    userOssQuery = this.apollo.watchQuery({
      query: gql` query{
            gcsViewCaseSummaryDetailsSecure(input: {
              JWT: "${sessionToken}",
              caseNumber:"${caseNumber}",
              caseTypeCode:"${caseType}",
              ipAddress:  "${ip}"
              screenId: "${screenId}",
            }) {
              POEndDate
              PONumber
              RequestType
              additionalComments
              answerToCust
              area
              billToDesc
              billToInfo
              caseNumber
              caseOwner
              caseType
              comments
              configuration
              company
              contact
              contamination
              contract
              courseName
              courseNumber
              customerPONum
              customerRef
              dateOccurred
              dateRequired
              decontaminateSteps
              description
              duration
              exposedTo
              family
              fieldServiceType
              group
              hardwareFailure
              hardwareUpgrade
              mepCreateDate
              mepModifyDate
              nextUpdate
              numberOfStudents
              ossPriority
              parts {
                description
                failureType
                failureTypeDesc
                partCreateDate
                partModifyDate
                partNumber
                quantity
                rev
                serialNumber
                serviceTime
              }
              partsRequired
              plannedShutdown
              priority
              problemDescription
              processDown
              processOperating
              processType
              processWetted
              productInfo
              repro
              reqDelivDate
              salesOrderNumber
              serviceRequired
              shipToDesc
              shipToInfo
              site
              softwareFailure
              softwareUpdgrade
              softwareVersion
              specialInstructions
              specialRequirements
              standardCourse
              status
              submittedBy
              submittedDate
              trainingLocation
              trainingType
              version
              warranty
              warrantyExpires
            }
          }
       `,
    });

    userOssQuery.valueChanges.subscribe((result) => {
      const resultData = result && result.data;
      const summaryData = resultData && resultData.gcsViewCaseSummaryDetailsSecure;
      sessionStorage.setItem(SessionVariables.ossSummaryCaseData, JSON.stringify(summaryData));
      this.service.ossCaseTypeSummaryCase.next(true);
    });
  }

  public mepGetParts (caseCode:number):void{
    debugger
    const sessionToken = sessionStorage.getItem(SessionVariables.sessionToken);

    let mepGetPartsQuery: QueryRef<any>;
    mepGetPartsQuery = this.apollo.watchQuery({
      query: gql`query{
         mepGetParts(input: {JWT: "${sessionToken}",, case_code: "${caseCode}"}) {
        CASE_ID
        Create_Date
        Description
        Failure_Type
        Failure_Type_Desc
        ID
        Modify_Date
        Part_Number
        Quantity
        Rev
        Serial_Number
        Service_Time
      }
        }

       `,
    });

    mepGetPartsQuery.valueChanges.subscribe((result)=>{
      if(result){
        // console.log(result)
        this.service.mepGetPartSubjets.next(result.data.mepGetParts)
      }


    },(err=>{
      console.log(err)

    }))


  }

  // mepGetOrderStatus
  public mepGetOrderStatus (caseNumber:number):void{
    debugger

    let mepGetOrderStatusQuery: QueryRef<any>;
    mepGetOrderStatusQuery = this.apollo.watchQuery({
      query: gql`query{
        getMepOrderTracking(input: {OrderId: "${caseNumber}"}) {
          mepNotificationOrderInfo {
            BackOrderQTY
            Carrier_Name
            CarrierRouting
            Carrier_URL
            Concat_Tracking_No
            Description
            LineItemNumber
            ModelCode
            OrderQTY
            TrackingNumber
            finalShipDate
          }
        }
      }

       `,
    });

    mepGetOrderStatusQuery.valueChanges.subscribe((result)=>{
      if(result){
        console.log(result)
        this.service.mepGetOrderSubjets.next(result.data.mepGetParts)
      }


    },(err=>{
      console.log(err)

    }))


  }
}
